
export default `

@media print {
  .print-table__print-button {
      display: none!important; 
  }
}

/*!
 * # Semantic UI 2.4.1 - Table
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */


/*******************************
             Table
*******************************/


/* Prototype */
.ui.table {
    width: 100%;
    background: #FFFFFF;
    margin: 1em 0em;
    border: 1px solid rgba(34, 36, 38, 0.15);
    -webkit-box-shadow: none;
    box-shadow: none;
    border-radius: 0.28571429rem;
    text-align: left;
    color: rgba(0, 0, 0, 0.87);
    border-collapse: separate;
    border-spacing: 0px;
}
.ui.table:first-child {
    margin-top: 0em;
}
.ui.table:last-child {
    margin-bottom: 0em;
}


/*******************************
             Parts
*******************************/


/* Table Content */
.ui.table th,
.ui.table td {
    -webkit-transition: background 0.1s ease, color 0.1s ease;
    transition: background 0.1s ease, color 0.1s ease;
}

/* Headers */
.ui.table thead {
    -webkit-box-shadow: none;
    box-shadow: none;
}
.ui.table thead th {
    cursor: auto;
    background: #F9FAFB;
    text-align: inherit;
    color: rgba(0, 0, 0, 0.87);
    padding: 0.92857143em 0.78571429em;
    vertical-align: inherit;
    font-style: none;
    font-weight: bold;
    text-transform: none;
    border-bottom: 1px solid rgba(34, 36, 38, 0.1);
    border-left: none;
}
.ui.table thead tr > th:first-child {
    border-left: none;
}
.ui.table thead tr:first-child > th:first-child {
    border-radius: 0.28571429rem 0em 0em 0em;
}
.ui.table thead tr:first-child > th:last-child {
    border-radius: 0em 0.28571429rem 0em 0em;
}
.ui.table thead tr:first-child > th:only-child {
    border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}

/* Footer */
.ui.table tfoot {
    -webkit-box-shadow: none;
    box-shadow: none;
}
.ui.table tfoot th {
    cursor: auto;
    border-top: 1px solid rgba(34, 36, 38, 0.15);
    background: #F9FAFB;
    text-align: inherit;
    color: rgba(0, 0, 0, 0.87);
    padding: 0.78571429em 0.78571429em;
    vertical-align: middle;
    font-style: normal;
    font-weight: normal;
    text-transform: none;
}
.ui.table tfoot tr > th:first-child {
    border-left: none;
}
.ui.table tfoot tr:first-child > th:first-child {
    border-radius: 0em 0em 0em 0.28571429rem;
}
.ui.table tfoot tr:first-child > th:last-child {
    border-radius: 0em 0em 0.28571429rem 0em;
}
.ui.table tfoot tr:first-child > th:only-child {
    border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}

/* Table Row */
.ui.table tr td {
    border-top: 1px solid rgba(34, 36, 38, 0.1);
}
.ui.table tr:first-child td {
    border-top: none;
}

/* Repeated tbody */
.ui.table tbody + tbody tr:first-child td {
    border-top: 1px solid rgba(34, 36, 38, 0.1);
}

/* Table Cells */
.ui.table td {
    padding: 0.78571429em 0.78571429em;
    text-align: inherit;
}

/* Icons */
.ui.table > .icon {
    vertical-align: baseline;
}
.ui.table > .icon:only-child {
    margin: 0em;
}

/* Table Segment */
.ui.table.segment {
    padding: 0em;
}
.ui.table.segment:after {
    display: none;
}
.ui.table.segment.stacked:after {
    display: block;
}

/* Responsive */
@media only screen and (max-width: 767px) {
    .ui.table:not(.unstackable) {
        width: 100%;
    }
    .ui.table:not(.unstackable) tbody,
    .ui.table:not(.unstackable) tr,
    .ui.table:not(.unstackable) tr > th,
    .ui.table:not(.unstackable) tr > td {
        width: auto !important;
        display: block !important;
    }
    .ui.table:not(.unstackable) {
        padding: 0em;
    }
    .ui.table:not(.unstackable) thead {
        display: block;
    }
    .ui.table:not(.unstackable) tfoot {
        display: block;
    }
    .ui.table:not(.unstackable) tr {
        padding-top: 1em;
        padding-bottom: 1em;
        -webkit-box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
        box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
    }
    .ui.table:not(.unstackable) tr > th,
    .ui.table:not(.unstackable) tr > td {
        background: none;
        border: none !important;
        padding: 0.25em 0.75em !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }
    .ui.table:not(.unstackable) th:first-child,
    .ui.table:not(.unstackable) td:first-child {
        font-weight: bold;
    }

    /* Definition Table */
    .ui.definition.table:not(.unstackable) thead th:first-child {
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }
}


/*******************************
            Coupling
*******************************/


/* UI Image */
.ui.table th .image,
.ui.table th .image img,
.ui.table td .image,
.ui.table td .image img {
    max-width: none;
}


/*******************************
             Types
*******************************/


/*--------------
    Complex
---------------*/

.ui.structured.table {
    border-collapse: collapse;
}
.ui.structured.table thead th {
    border-left: none;
    border-right: none;
}
.ui.structured.sortable.table thead th {
    border-left: 1px solid rgba(34, 36, 38, 0.15);
    border-right: 1px solid rgba(34, 36, 38, 0.15);
}
.ui.structured.basic.table th {
    border-left: none;
    border-right: none;
}
.ui.structured.celled.table tr th,
.ui.structured.celled.table tr td {
    border-left: 1px solid rgba(34, 36, 38, 0.1);
    border-right: 1px solid rgba(34, 36, 38, 0.1);
}

/*--------------
   Definition
---------------*/

.ui.definition.table thead:not(.full-width) th:first-child {
    pointer-events: none;
    background: transparent;
    font-weight: normal;
    color: rgba(0, 0, 0, 0.4);
    -webkit-box-shadow: -1px -1px 0px 1px #FFFFFF;
    box-shadow: -1px -1px 0px 1px #FFFFFF;
}
.ui.definition.table tfoot:not(.full-width) th:first-child {
    pointer-events: none;
    background: transparent;
    font-weight: rgba(0, 0, 0, 0.4);
    color: normal;
    -webkit-box-shadow: 1px 1px 0px 1px #FFFFFF;
    box-shadow: 1px 1px 0px 1px #FFFFFF;
}

/* Remove Border */
.ui.celled.definition.table thead:not(.full-width) th:first-child {
    -webkit-box-shadow: 0px -1px 0px 1px #FFFFFF;
    box-shadow: 0px -1px 0px 1px #FFFFFF;
}
.ui.celled.definition.table tfoot:not(.full-width) th:first-child {
    -webkit-box-shadow: 0px 1px 0px 1px #FFFFFF;
    box-shadow: 0px 1px 0px 1px #FFFFFF;
}

/* Highlight Defining Column */
.ui.definition.table tr td:first-child:not(.ignored),
.ui.definition.table tr td.definition {
    background: rgba(0, 0, 0, 0.03);
    font-weight: bold;
    color: rgba(0, 0, 0, 0.95);
    text-transform: '';
    -webkit-box-shadow: '';
    box-shadow: '';
    text-align: '';
    font-size: 1em;
    padding-left: '';
    padding-right: '';
}

/* Fix 2nd Column */
.ui.definition.table thead:not(.full-width) th:nth-child(2) {
    border-left: 1px solid rgba(34, 36, 38, 0.15);
}
.ui.definition.table tfoot:not(.full-width) th:nth-child(2) {
    border-left: 1px solid rgba(34, 36, 38, 0.15);
}
.ui.definition.table td:nth-child(2) {
    border-left: 1px solid rgba(34, 36, 38, 0.15);
}


/*******************************
             States
*******************************/


/*--------------
    Positive
---------------*/

.ui.table tr.positive,
.ui.table td.positive {
    -webkit-box-shadow: 0px 0px 0px #A3C293 inset;
    box-shadow: 0px 0px 0px #A3C293 inset;
}
.ui.table tr.positive,
.ui.table td.positive {
    background: #FCFFF5 !important;
    color: #2C662D !important;
}

/*--------------
     Negative
---------------*/

.ui.table tr.negative,
.ui.table td.negative {
    -webkit-box-shadow: 0px 0px 0px #E0B4B4 inset;
    box-shadow: 0px 0px 0px #E0B4B4 inset;
}
.ui.table tr.negative,
.ui.table td.negative {
    background: #FFF6F6 !important;
    color: #9F3A38 !important;
}

/*--------------
      Error
---------------*/

.ui.table tr.error,
.ui.table td.error {
    -webkit-box-shadow: 0px 0px 0px #E0B4B4 inset;
    box-shadow: 0px 0px 0px #E0B4B4 inset;
}
.ui.table tr.error,
.ui.table td.error {
    background: #FFF6F6 !important;
    color: #9F3A38 !important;
}

/*--------------
     Warning
---------------*/

.ui.table tr.warning,
.ui.table td.warning {
    -webkit-box-shadow: 0px 0px 0px #C9BA9B inset;
    box-shadow: 0px 0px 0px #C9BA9B inset;
}
.ui.table tr.warning,
.ui.table td.warning {
    background: #FFFAF3 !important;
    color: #573A08 !important;
}

/*--------------
     Active
---------------*/

.ui.table tr.active,
.ui.table td.active {
    -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.87) inset;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.87) inset;
}
.ui.table tr.active,
.ui.table td.active {
    background: #E0E0E0 !important;
    color: rgba(0, 0, 0, 0.87) !important;
}

/*--------------
     Disabled
---------------*/

.ui.table tr.disabled td,
.ui.table tr td.disabled,
.ui.table tr.disabled:hover,
.ui.table tr:hover td.disabled {
    pointer-events: none;
    color: rgba(40, 40, 40, 0.3);
}


/*******************************
          Variations
*******************************/


/*--------------
    Stackable
---------------*/

@media only screen and (max-width: 991px) {
    .ui[class*="tablet stackable"].table,
    .ui[class*="tablet stackable"].table tbody,
    .ui[class*="tablet stackable"].table tr,
    .ui[class*="tablet stackable"].table tr > th,
    .ui[class*="tablet stackable"].table tr > td {
        width: 100% !important;
        display: block !important;
    }
    .ui[class*="tablet stackable"].table {
        padding: 0em;
    }
    .ui[class*="tablet stackable"].table thead {
        display: block;
    }
    .ui[class*="tablet stackable"].table tfoot {
        display: block;
    }
    .ui[class*="tablet stackable"].table tr {
        padding-top: 1em;
        padding-bottom: 1em;
        -webkit-box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
        box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
    }
    .ui[class*="tablet stackable"].table tr > th,
    .ui[class*="tablet stackable"].table tr > td {
        background: none;
        border: none !important;
        padding: 0.25em 0.75em;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }

    /* Definition Table */
    .ui.definition[class*="tablet stackable"].table thead th:first-child {
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }
}

/*--------------
 Text Alignment
---------------*/

.ui.table[class*="left aligned"],
.ui.table [class*="left aligned"] {
    text-align: left;
}
.ui.table[class*="center aligned"],
.ui.table [class*="center aligned"] {
    text-align: center;
}
.ui.table[class*="right aligned"],
.ui.table [class*="right aligned"] {
    text-align: right;
}

/*------------------
 Vertical Alignment
------------------*/

.ui.table[class*="top aligned"],
.ui.table [class*="top aligned"] {
    vertical-align: top;
}
.ui.table[class*="middle aligned"],
.ui.table [class*="middle aligned"] {
    vertical-align: middle;
}
.ui.table[class*="bottom aligned"],
.ui.table [class*="bottom aligned"] {
    vertical-align: bottom;
}

/*--------------
    Collapsing
---------------*/

.ui.table th.collapsing,
.ui.table td.collapsing {
    width: 1px;
    white-space: nowrap;
}

/*--------------
     Fixed
---------------*/

.ui.fixed.table {
    table-layout: fixed;
}
.ui.fixed.table th,
.ui.fixed.table td {
    overflow: hidden;
    text-overflow: ellipsis;
}

/*--------------
   Selectable
---------------*/

.ui.selectable.table tbody tr:hover,
.ui.table tbody tr td.selectable:hover {
    background: rgba(0, 0, 0, 0.05) !important;
    color: rgba(0, 0, 0, 0.95) !important;
}
.ui.selectable.inverted.table tbody tr:hover,
.ui.inverted.table tbody tr td.selectable:hover {
    background: rgba(255, 255, 255, 0.08) !important;
    color: #ffffff !important;
}

/* Selectable Cell Link */
.ui.table tbody tr td.selectable {
    padding: 0em;
}
.ui.table tbody tr td.selectable > a:not(.ui) {
    display: block;
    color: inherit;
    padding: 0.78571429em 0.78571429em;
}

/* Other States */
.ui.selectable.table tr.error:hover,
.ui.table tr td.selectable.error:hover,
.ui.selectable.table tr:hover td.error {
    background: #ffe7e7 !important;
    color: #943634 !important;
}
.ui.selectable.table tr.warning:hover,
.ui.table tr td.selectable.warning:hover,
.ui.selectable.table tr:hover td.warning {
    background: #fff4e4 !important;
    color: #493107 !important;
}
.ui.selectable.table tr.active:hover,
.ui.table tr td.selectable.active:hover,
.ui.selectable.table tr:hover td.active {
    background: #E0E0E0 !important;
    color: rgba(0, 0, 0, 0.87) !important;
}
.ui.selectable.table tr.positive:hover,
.ui.table tr td.selectable.positive:hover,
.ui.selectable.table tr:hover td.positive {
    background: #f7ffe6 !important;
    color: #275b28 !important;
}
.ui.selectable.table tr.negative:hover,
.ui.table tr td.selectable.negative:hover,
.ui.selectable.table tr:hover td.negative {
    background: #ffe7e7 !important;
    color: #943634 !important;
}

/*-------------------
      Attached
--------------------*/


/* Middle */
.ui.attached.table {
    top: 0px;
    bottom: 0px;
    border-radius: 0px;
    margin: 0em -1px;
    width: calc(100% - (-1px * 2));
    max-width: calc(100% - (-1px * 2));
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 1px solid #D4D4D5;
}
.ui.attached + .ui.attached.table:not(.top) {
    border-top: none;
}

/* Top */
.ui[class*="top attached"].table {
    bottom: 0px;
    margin-bottom: 0em;
    top: 0px;
    margin-top: 1em;
    border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.table[class*="top attached"]:first-child {
    margin-top: 0em;
}

/* Bottom */
.ui[class*="bottom attached"].table {
    bottom: 0px;
    margin-top: 0em;
    top: 0px;
    margin-bottom: 1em;
    -webkit-box-shadow: none, none;
    box-shadow: none, none;
    border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui[class*="bottom attached"].table:last-child {
    margin-bottom: 0em;
}

/*--------------
     Striped
---------------*/


/* Table Striping */
.ui.striped.table > tr:nth-child(2n),
.ui.striped.table tbody tr:nth-child(2n) {
    background-color: rgba(0, 0, 50, 0.02);
}

/* Stripes */
.ui.inverted.striped.table > tr:nth-child(2n),
.ui.inverted.striped.table tbody tr:nth-child(2n) {
    background-color: rgba(255, 255, 255, 0.05);
}

/* Allow striped active hover */
.ui.striped.selectable.selectable.selectable.table tbody tr.active:hover {
    background: #EFEFEF !important;
    color: rgba(0, 0, 0, 0.95) !important;
}

/*--------------
   Single Line
---------------*/

.ui.table[class*="single line"],
.ui.table [class*="single line"] {
    white-space: nowrap;
}
.ui.table[class*="single line"],
.ui.table [class*="single line"] {
    white-space: nowrap;
}

/*-------------------
       Colors
--------------------*/


/* Red */
.ui.red.table {
    border-top: 0.2em solid #DB2828;
}
.ui.inverted.red.table {
    background-color: #DB2828 !important;
    color: #FFFFFF !important;
}

/* Orange */
.ui.orange.table {
    border-top: 0.2em solid #F2711C;
}
.ui.inverted.orange.table {
    background-color: #F2711C !important;
    color: #FFFFFF !important;
}

/* Yellow */
.ui.yellow.table {
    border-top: 0.2em solid #FBBD08;
}
.ui.inverted.yellow.table {
    background-color: #FBBD08 !important;
    color: #FFFFFF !important;
}

/* Olive */
.ui.olive.table {
    border-top: 0.2em solid #B5CC18;
}
.ui.inverted.olive.table {
    background-color: #B5CC18 !important;
    color: #FFFFFF !important;
}

/* Green */
.ui.green.table {
    border-top: 0.2em solid #21BA45;
}
.ui.inverted.green.table {
    background-color: #21BA45 !important;
    color: #FFFFFF !important;
}

/* Teal */
.ui.teal.table {
    border-top: 0.2em solid #00B5AD;
}
.ui.inverted.teal.table {
    background-color: #00B5AD !important;
    color: #FFFFFF !important;
}

/* Blue */
.ui.blue.table {
    border-top: 0.2em solid #2185D0;
}
.ui.inverted.blue.table {
    background-color: #2185D0 !important;
    color: #FFFFFF !important;
}

/* Violet */
.ui.violet.table {
    border-top: 0.2em solid #6435C9;
}
.ui.inverted.violet.table {
    background-color: #6435C9 !important;
    color: #FFFFFF !important;
}

/* Purple */
.ui.purple.table {
    border-top: 0.2em solid #A333C8;
}
.ui.inverted.purple.table {
    background-color: #A333C8 !important;
    color: #FFFFFF !important;
}

/* Pink */
.ui.pink.table {
    border-top: 0.2em solid #E03997;
}
.ui.inverted.pink.table {
    background-color: #E03997 !important;
    color: #FFFFFF !important;
}

/* Brown */
.ui.brown.table {
    border-top: 0.2em solid #A5673F;
}
.ui.inverted.brown.table {
    background-color: #A5673F !important;
    color: #FFFFFF !important;
}

/* Grey */
.ui.grey.table {
    border-top: 0.2em solid #767676;
}
.ui.inverted.grey.table {
    background-color: #767676 !important;
    color: #FFFFFF !important;
}

/* Black */
.ui.black.table {
    border-top: 0.2em solid #1B1C1D;
}
.ui.inverted.black.table {
    background-color: #1B1C1D !important;
    color: #FFFFFF !important;
}

/*--------------
  Column Count
---------------*/


/* Grid Based */
.ui.one.column.table td {
    width: 100%;
}
.ui.two.column.table td {
    width: 50%;
}
.ui.three.column.table td {
    width: 33.33333333%;
}
.ui.four.column.table td {
    width: 25%;
}
.ui.five.column.table td {
    width: 20%;
}
.ui.six.column.table td {
    width: 16.66666667%;
}
.ui.seven.column.table td {
    width: 14.28571429%;
}
.ui.eight.column.table td {
    width: 12.5%;
}
.ui.nine.column.table td {
    width: 11.11111111%;
}
.ui.ten.column.table td {
    width: 10%;
}
.ui.eleven.column.table td {
    width: 9.09090909%;
}
.ui.twelve.column.table td {
    width: 8.33333333%;
}
.ui.thirteen.column.table td {
    width: 7.69230769%;
}
.ui.fourteen.column.table td {
    width: 7.14285714%;
}
.ui.fifteen.column.table td {
    width: 6.66666667%;
}
.ui.sixteen.column.table td {
    width: 6.25%;
}

/* Column Width */
.ui.table th.one.wide,
.ui.table td.one.wide {
    width: 6.25%;
}
.ui.table th.two.wide,
.ui.table td.two.wide {
    width: 12.5%;
}
.ui.table th.three.wide,
.ui.table td.three.wide {
    width: 18.75%;
}
.ui.table th.four.wide,
.ui.table td.four.wide {
    width: 25%;
}
.ui.table th.five.wide,
.ui.table td.five.wide {
    width: 31.25%;
}
.ui.table th.six.wide,
.ui.table td.six.wide {
    width: 37.5%;
}
.ui.table th.seven.wide,
.ui.table td.seven.wide {
    width: 43.75%;
}
.ui.table th.eight.wide,
.ui.table td.eight.wide {
    width: 50%;
}
.ui.table th.nine.wide,
.ui.table td.nine.wide {
    width: 56.25%;
}
.ui.table th.ten.wide,
.ui.table td.ten.wide {
    width: 62.5%;
}
.ui.table th.eleven.wide,
.ui.table td.eleven.wide {
    width: 68.75%;
}
.ui.table th.twelve.wide,
.ui.table td.twelve.wide {
    width: 75%;
}
.ui.table th.thirteen.wide,
.ui.table td.thirteen.wide {
    width: 81.25%;
}
.ui.table th.fourteen.wide,
.ui.table td.fourteen.wide {
    width: 87.5%;
}
.ui.table th.fifteen.wide,
.ui.table td.fifteen.wide {
    width: 93.75%;
}
.ui.table th.sixteen.wide,
.ui.table td.sixteen.wide {
    width: 100%;
}

/*--------------
    Sortable
---------------*/

.ui.sortable.table thead th {
    cursor: pointer;
    white-space: nowrap;
    border-left: 1px solid rgba(34, 36, 38, 0.15);
    color: rgba(0, 0, 0, 0.87);
}
.ui.sortable.table thead th:first-child {
    border-left: none;
}
.ui.sortable.table thead th.sorted,
.ui.sortable.table thead th.sorted:hover {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.ui.sortable.table thead th:after {
    display: none;
    font-style: normal;
    font-weight: normal;
    text-decoration: inherit;
    content: '';
    height: 1em;
    width: auto;
    opacity: 0.8;
    margin: 0em 0em 0em 0.5em;
    font-family: 'Icons';
}
.ui.sortable.table thead th.ascending:after {
    content: '\f0d8';
}
.ui.sortable.table thead th.descending:after {
    content: '\f0d7';
}

/* Hover */
.ui.sortable.table th.disabled:hover {
    cursor: auto;
    color: rgba(40, 40, 40, 0.3);
}
.ui.sortable.table thead th:hover {
    background: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.8);
}

/* Sorted */
.ui.sortable.table thead th.sorted {
    background: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.95);
}
.ui.sortable.table thead th.sorted:after {
    display: inline-block;
}

/* Sorted Hover */
.ui.sortable.table thead th.sorted:hover {
    background: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.95);
}

/* Inverted */
.ui.inverted.sortable.table thead th.sorted {
    background: rgba(255, 255, 255, 0.15) -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0, 0, 0, 0.05)));
    background: rgba(255, 255, 255, 0.15) -webkit-linear-gradient(transparent, rgba(0, 0, 0, 0.05));
    background: rgba(255, 255, 255, 0.15) linear-gradient(transparent, rgba(0, 0, 0, 0.05));
    color: #ffffff;
}
.ui.inverted.sortable.table thead th:hover {
    background: rgba(255, 255, 255, 0.08) -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0, 0, 0, 0.05)));
    background: rgba(255, 255, 255, 0.08) -webkit-linear-gradient(transparent, rgba(0, 0, 0, 0.05));
    background: rgba(255, 255, 255, 0.08) linear-gradient(transparent, rgba(0, 0, 0, 0.05));
    color: #ffffff;
}
.ui.inverted.sortable.table thead th {
    border-left-color: transparent;
    border-right-color: transparent;
}

/*--------------
    Inverted
---------------*/


/* Text Color */
.ui.inverted.table {
    background: #333333;
    color: rgba(255, 255, 255, 0.9);
    border: none;
}
.ui.inverted.table th {
    background-color: rgba(0, 0, 0, 0.15);
    border-color: rgba(255, 255, 255, 0.1) !important;
    color: rgba(255, 255, 255, 0.9) !important;
}
.ui.inverted.table tr td {
    border-color: rgba(255, 255, 255, 0.1) !important;
}
.ui.inverted.table tr.disabled td,
.ui.inverted.table tr td.disabled,
.ui.inverted.table tr.disabled:hover td,
.ui.inverted.table tr:hover td.disabled {
    pointer-events: none;
    color: rgba(225, 225, 225, 0.3);
}

/* Definition */
.ui.inverted.definition.table tfoot:not(.full-width) th:first-child,
.ui.inverted.definition.table thead:not(.full-width) th:first-child {
    background: #FFFFFF;
}
.ui.inverted.definition.table tr td:first-child {
    background: rgba(255, 255, 255, 0.02);
    color: #ffffff;
}

/*--------------
   Collapsing
---------------*/

.ui.collapsing.table {
    width: auto;
}

/*--------------
      Basic
---------------*/

.ui.basic.table {
    background: transparent;
    border: 1px solid rgba(34, 36, 38, 0.15);
    -webkit-box-shadow: none;
    box-shadow: none;
}
.ui.basic.table thead,
.ui.basic.table tfoot {
    -webkit-box-shadow: none;
    box-shadow: none;
}
.ui.basic.table th {
    background: transparent;
    border-left: none;
}
.ui.basic.table tbody tr {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.ui.basic.table td {
    background: transparent;
}
.ui.basic.striped.table tbody tr:nth-child(2n) {
    background-color: rgba(0, 0, 0, 0.05) !important;
}

/* Very Basic */
.ui[class*="very basic"].table {
    border: none;
}
.ui[class*="very basic"].table:not(.sortable):not(.striped) th,
.ui[class*="very basic"].table:not(.sortable):not(.striped) td {
    padding: '';
}
.ui[class*="very basic"].table:not(.sortable):not(.striped) th:first-child,
.ui[class*="very basic"].table:not(.sortable):not(.striped) td:first-child {
    padding-left: 0em;
}
.ui[class*="very basic"].table:not(.sortable):not(.striped) th:last-child,
.ui[class*="very basic"].table:not(.sortable):not(.striped) td:last-child {
    padding-right: 0em;
}
.ui[class*="very basic"].table:not(.sortable):not(.striped) thead tr:first-child th {
    padding-top: 0em;
}

/*--------------
     Celled
---------------*/

.ui.celled.table tr th,
.ui.celled.table tr td {
    border-left: 1px solid rgba(34, 36, 38, 0.1);
}
.ui.celled.table tr th:first-child,
.ui.celled.table tr td:first-child {
    border-left: none;
}

/*--------------
     Padded
---------------*/

.ui.padded.table th {
    padding-left: 1em;
    padding-right: 1em;
}
.ui.padded.table th,
.ui.padded.table td {
    padding: 1em 1em;
}

/* Very */
.ui[class*="very padded"].table th {
    padding-left: 1.5em;
    padding-right: 1.5em;
}
.ui[class*="very padded"].table td {
    padding: 1.5em 1.5em;
}

/*--------------
     Compact
---------------*/

.ui.compact.table th {
    padding-left: 0.7em;
    padding-right: 0.7em;
}
.ui.compact.table td {
    padding: 0.5em 0.7em;
}

/* Very */
.ui[class*="very compact"].table th {
    padding-left: 0.6em;
    padding-right: 0.6em;
}
.ui[class*="very compact"].table td {
    padding: 0.4em 0.6em;
}

/*--------------
      Sizes
---------------*/


/* Small */
.ui.small.table {
    font-size: 0.9em;
}

/* Standard */
.ui.table {
    font-size: 1em;
}

/* Large */
.ui.large.table {
    font-size: 1.1em;
}


/*******************************
         Site Overrides
*******************************/


/*!
 * # Semantic UI 2.4.1 - Button
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */


/*******************************
            Button
*******************************/

.ui.button {
    cursor: pointer;
    display: inline-block;
    min-height: 1em;
    outline: none;
    border: none;
    vertical-align: baseline;
    background: #E0E1E2 none;
    color: rgba(0, 0, 0, 0.6);
    font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
    margin: 0em 0.25em 0em 0em;
    padding: 0.78571429em 1.5em 0.78571429em;
    text-transform: none;
    text-shadow: none;
    font-weight: bold;
    line-height: 1em;
    font-style: normal;
    text-align: center;
    text-decoration: none;
    border-radius: 0.28571429rem;
    -webkit-box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, background 0.1s ease, -webkit-box-shadow 0.1s ease;
    transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, background 0.1s ease, -webkit-box-shadow 0.1s ease;
    transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;
    transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease, -webkit-box-shadow 0.1s ease;
    will-change: '';
    -webkit-tap-highlight-color: transparent;
}


/*******************************
            States
*******************************/


/*--------------
      Hover
---------------*/

.ui.button:hover {
    background-color: #CACBCD;
    background-image: none;
    -webkit-box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    color: rgba(0, 0, 0, 0.8);
}
.ui.button:hover .icon {
    opacity: 0.85;
}

/*--------------
      Focus
---------------*/

.ui.button:focus {
    background-color: #CACBCD;
    color: rgba(0, 0, 0, 0.8);
    background-image: '' !important;
    -webkit-box-shadow: '' !important;
    box-shadow: '' !important;
}
.ui.button:focus .icon {
    opacity: 0.85;
}

/*--------------
      Down
---------------*/

.ui.button:active,
.ui.active.button:active {
    background-color: #BABBBC;
    background-image: '';
    color: rgba(0, 0, 0, 0.9);
    -webkit-box-shadow: 0px 0px 0px 1px transparent inset, none;
    box-shadow: 0px 0px 0px 1px transparent inset, none;
}

/*--------------
     Active
---------------*/

.ui.active.button {
    background-color: #C0C1C2;
    background-image: none;
    -webkit-box-shadow: 0px 0px 0px 1px transparent inset;
    box-shadow: 0px 0px 0px 1px transparent inset;
    color: rgba(0, 0, 0, 0.95);
}
.ui.active.button:hover {
    background-color: #C0C1C2;
    background-image: none;
    color: rgba(0, 0, 0, 0.95);
}
.ui.active.button:active {
    background-color: #C0C1C2;
    background-image: none;
}

/*--------------
    Loading
---------------*/


/* Specificity hack */
.ui.loading.loading.loading.loading.loading.loading.button {
    position: relative;
    cursor: default;
    text-shadow: none !important;
    color: transparent !important;
    opacity: 1;
    pointer-events: auto;
    -webkit-transition: all 0s linear, opacity 0.1s ease;
    transition: all 0s linear, opacity 0.1s ease;
}
.ui.loading.button:before {
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    margin: -0.64285714em 0em 0em -0.64285714em;
    width: 1.28571429em;
    height: 1.28571429em;
    border-radius: 500rem;
    border: 0.2em solid rgba(0, 0, 0, 0.15);
}
.ui.loading.button:after {
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    margin: -0.64285714em 0em 0em -0.64285714em;
    width: 1.28571429em;
    height: 1.28571429em;
    -webkit-animation: button-spin 0.6s linear;
    animation: button-spin 0.6s linear;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    border-radius: 500rem;
    border-color: #FFFFFF transparent transparent;
    border-style: solid;
    border-width: 0.2em;
    -webkit-box-shadow: 0px 0px 0px 1px transparent;
    box-shadow: 0px 0px 0px 1px transparent;
}
.ui.labeled.icon.loading.button .icon {
    background-color: transparent;
    -webkit-box-shadow: none;
    box-shadow: none;
}
@-webkit-keyframes button-spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@keyframes button-spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
.ui.basic.loading.button:not(.inverted):before {
    border-color: rgba(0, 0, 0, 0.1);
}
.ui.basic.loading.button:not(.inverted):after {
    border-top-color: #767676;
}

/*-------------------
      Disabled
--------------------*/

.ui.buttons .disabled.button,
.ui.disabled.button,
.ui.button:disabled,
.ui.disabled.button:hover,
.ui.disabled.active.button {
    cursor: default;
    opacity: 0.45 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    pointer-events: none !important;
}

/* Basic Group With Disabled */
.ui.basic.buttons .ui.disabled.button {
    border-color: rgba(34, 36, 38, 0.5);
}


/*******************************
             Types
*******************************/


/*-------------------
       Animated
--------------------*/

.ui.animated.button {
    position: relative;
    overflow: hidden;
    padding-right: 0em !important;
    vertical-align: middle;
    z-index: 1;
}
.ui.animated.button .content {
    will-change: transform, opacity;
}
.ui.animated.button .visible.content {
    position: relative;
    margin-right: 1.5em;
}
.ui.animated.button .hidden.content {
    position: absolute;
    width: 100%;
}

/* Horizontal */
.ui.animated.button .visible.content,
.ui.animated.button .hidden.content {
    -webkit-transition: right 0.3s ease 0s;
    transition: right 0.3s ease 0s;
}
.ui.animated.button .visible.content {
    left: auto;
    right: 0%;
}
.ui.animated.button .hidden.content {
    top: 50%;
    left: auto;
    right: -100%;
    margin-top: -0.5em;
}
.ui.animated.button:focus .visible.content,
.ui.animated.button:hover .visible.content {
    left: auto;
    right: 200%;
}
.ui.animated.button:focus .hidden.content,
.ui.animated.button:hover .hidden.content {
    left: auto;
    right: 0%;
}

/* Vertical */
.ui.vertical.animated.button .visible.content,
.ui.vertical.animated.button .hidden.content {
    -webkit-transition: top 0.3s ease, -webkit-transform 0.3s ease;
    transition: top 0.3s ease, -webkit-transform 0.3s ease;
    transition: top 0.3s ease, transform 0.3s ease;
    transition: top 0.3s ease, transform 0.3s ease, -webkit-transform 0.3s ease;
}
.ui.vertical.animated.button .visible.content {
    -webkit-transform: translateY(0%);
    transform: translateY(0%);
    right: auto;
}
.ui.vertical.animated.button .hidden.content {
    top: -50%;
    left: 0%;
    right: auto;
}
.ui.vertical.animated.button:focus .visible.content,
.ui.vertical.animated.button:hover .visible.content {
    -webkit-transform: translateY(200%);
    transform: translateY(200%);
    right: auto;
}
.ui.vertical.animated.button:focus .hidden.content,
.ui.vertical.animated.button:hover .hidden.content {
    top: 50%;
    right: auto;
}

/* Fade */
.ui.fade.animated.button .visible.content,
.ui.fade.animated.button .hidden.content {
    -webkit-transition: opacity 0.3s ease, -webkit-transform 0.3s ease;
    transition: opacity 0.3s ease, -webkit-transform 0.3s ease;
    transition: opacity 0.3s ease, transform 0.3s ease;
    transition: opacity 0.3s ease, transform 0.3s ease, -webkit-transform 0.3s ease;
}
.ui.fade.animated.button .visible.content {
    left: auto;
    right: auto;
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
}
.ui.fade.animated.button .hidden.content {
    opacity: 0;
    left: 0%;
    right: auto;
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
}
.ui.fade.animated.button:focus .visible.content,
.ui.fade.animated.button:hover .visible.content {
    left: auto;
    right: auto;
    opacity: 0;
    -webkit-transform: scale(0.75);
    transform: scale(0.75);
}
.ui.fade.animated.button:focus .hidden.content,
.ui.fade.animated.button:hover .hidden.content {
    left: 0%;
    right: auto;
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
}

/*-------------------
       Inverted
--------------------*/

.ui.inverted.button {
    -webkit-box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;
    box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;
    background: transparent none;
    color: #FFFFFF;
    text-shadow: none !important;
}

/* Group */
.ui.inverted.buttons .button {
    margin: 0px 0px 0px -2px;
}
.ui.inverted.buttons .button:first-child {
    margin-left: 0em;
}
.ui.inverted.vertical.buttons .button {
    margin: 0px 0px -2px 0px;
}
.ui.inverted.vertical.buttons .button:first-child {
    margin-top: 0em;
}

/* States */

/* Hover */
.ui.inverted.button:hover {
    background: #FFFFFF;
    -webkit-box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;
    box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;
    color: rgba(0, 0, 0, 0.8);
}

/* Active / Focus */
.ui.inverted.button:focus,
.ui.inverted.button.active {
    background: #FFFFFF;
    -webkit-box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;
    box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;
    color: rgba(0, 0, 0, 0.8);
}

/* Active Focus */
.ui.inverted.button.active:focus {
    background: #DCDDDE;
    -webkit-box-shadow: 0px 0px 0px 2px #DCDDDE inset !important;
    box-shadow: 0px 0px 0px 2px #DCDDDE inset !important;
    color: rgba(0, 0, 0, 0.8);
}

/*-------------------
    Labeled Button
--------------------*/

.ui.labeled.button:not(.icon) {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    background: none !important;
    padding: 0px !important;
    border: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}
.ui.labeled.button > .button {
    margin: 0px;
}
.ui.labeled.button > .label {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0px 0px 0px -1px !important;
    padding: '';
    font-size: 1em;
    border-color: rgba(34, 36, 38, 0.15);
}

/* Tag */
.ui.labeled.button > .tag.label:before {
    width: 1.85em;
    height: 1.85em;
}

/* Right */
.ui.labeled.button:not([class*="left labeled"]) > .button {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}
.ui.labeled.button:not([class*="left labeled"]) > .label {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

/* Left Side */
.ui[class*="left labeled"].button > .button {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}
.ui[class*="left labeled"].button > .label {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

/*-------------------
       Social
--------------------*/


/* Facebook */
.ui.facebook.button {
    background-color: #3B5998;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.facebook.button:hover {
    background-color: #304d8a;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.facebook.button:active {
    background-color: #2d4373;
    color: #FFFFFF;
    text-shadow: none;
}

/* Twitter */
.ui.twitter.button {
    background-color: #55ACEE;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.twitter.button:hover {
    background-color: #35a2f4;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.twitter.button:active {
    background-color: #2795e9;
    color: #FFFFFF;
    text-shadow: none;
}

/* Google Plus */
.ui.google.plus.button {
    background-color: #DD4B39;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.google.plus.button:hover {
    background-color: #e0321c;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.google.plus.button:active {
    background-color: #c23321;
    color: #FFFFFF;
    text-shadow: none;
}

/* Linked In */
.ui.linkedin.button {
    background-color: #1F88BE;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.linkedin.button:hover {
    background-color: #147baf;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.linkedin.button:active {
    background-color: #186992;
    color: #FFFFFF;
    text-shadow: none;
}

/* YouTube */
.ui.youtube.button {
    background-color: #FF0000;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.youtube.button:hover {
    background-color: #e60000;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.youtube.button:active {
    background-color: #cc0000;
    color: #FFFFFF;
    text-shadow: none;
}

/* Instagram */
.ui.instagram.button {
    background-color: #49769C;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.instagram.button:hover {
    background-color: #3d698e;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.instagram.button:active {
    background-color: #395c79;
    color: #FFFFFF;
    text-shadow: none;
}

/* Pinterest */
.ui.pinterest.button {
    background-color: #BD081C;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.pinterest.button:hover {
    background-color: #ac0013;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.pinterest.button:active {
    background-color: #8c0615;
    color: #FFFFFF;
    text-shadow: none;
}

/* VK */
.ui.vk.button {
    background-color: #4D7198;
    color: #FFFFFF;
    background-image: none;
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.vk.button:hover {
    background-color: #41648a;
    color: #FFFFFF;
}
.ui.vk.button:active {
    background-color: #3c5876;
    color: #FFFFFF;
}

/*--------------
     Icon
---------------*/

.ui.button > .icon:not(.button) {
    height: 0.85714286em;
    opacity: 0.8;
    margin: 0em 0.42857143em 0em -0.21428571em;
    -webkit-transition: opacity 0.1s ease;
    transition: opacity 0.1s ease;
    vertical-align: '';
    color: '';
}
.ui.button:not(.icon) > .icon:not(.button):not(.dropdown) {
    margin: 0em 0.42857143em 0em -0.21428571em;
}
.ui.button:not(.icon) > .right.icon:not(.button):not(.dropdown) {
    margin: 0em -0.21428571em 0em 0.42857143em;
}


/*******************************
           Variations
*******************************/


/*-------------------
       Floated
--------------------*/

.ui[class*="left floated"].buttons,
.ui[class*="left floated"].button {
    float: left;
    margin-left: 0em;
    margin-right: 0.25em;
}
.ui[class*="right floated"].buttons,
.ui[class*="right floated"].button {
    float: right;
    margin-right: 0em;
    margin-left: 0.25em;
}

/*-------------------
       Compact
--------------------*/

.ui.compact.buttons .button,
.ui.compact.button {
    padding: 0.58928571em 1.125em 0.58928571em;
}
.ui.compact.icon.buttons .button,
.ui.compact.icon.button {
    padding: 0.58928571em 0.58928571em 0.58928571em;
}
.ui.compact.labeled.icon.buttons .button,
.ui.compact.labeled.icon.button {
    padding: 0.58928571em 3.69642857em 0.58928571em;
}

/*-------------------
        Sizes
--------------------*/

.ui.mini.buttons .button,
.ui.mini.buttons .or,
.ui.mini.button {
    font-size: 0.78571429rem;
}
.ui.tiny.buttons .button,
.ui.tiny.buttons .or,
.ui.tiny.button {
    font-size: 0.85714286rem;
}
.ui.small.buttons .button,
.ui.small.buttons .or,
.ui.small.button {
    font-size: 0.92857143rem;
}
.ui.buttons .button,
.ui.buttons .or,
.ui.button {
    font-size: 1rem;
}
.ui.large.buttons .button,
.ui.large.buttons .or,
.ui.large.button {
    font-size: 1.14285714rem;
}
.ui.big.buttons .button,
.ui.big.buttons .or,
.ui.big.button {
    font-size: 1.28571429rem;
}
.ui.huge.buttons .button,
.ui.huge.buttons .or,
.ui.huge.button {
    font-size: 1.42857143rem;
}
.ui.massive.buttons .button,
.ui.massive.buttons .or,
.ui.massive.button {
    font-size: 1.71428571rem;
}

/*--------------
    Icon Only
---------------*/

.ui.icon.buttons .button,
.ui.icon.button {
    padding: 0.78571429em 0.78571429em 0.78571429em;
}
.ui.icon.buttons .button > .icon,
.ui.icon.button > .icon {
    opacity: 0.9;
    margin: 0em !important;
    vertical-align: top;
}

/*-------------------
        Basic
--------------------*/

.ui.basic.buttons .button,
.ui.basic.button {
    background: transparent none !important;
    color: rgba(0, 0, 0, 0.6) !important;
    font-weight: normal;
    border-radius: 0.28571429rem;
    text-transform: none;
    text-shadow: none !important;
    -webkit-box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.15) inset;
}
.ui.basic.buttons {
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 0.28571429rem;
}
.ui.basic.buttons .button {
    border-radius: 0em;
}
.ui.basic.buttons .button:hover,
.ui.basic.button:hover {
    background: #FFFFFF !important;
    color: rgba(0, 0, 0, 0.8) !important;
    -webkit-box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.35) inset, 0px 0px 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.35) inset, 0px 0px 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.basic.buttons .button:focus,
.ui.basic.button:focus {
    background: #FFFFFF !important;
    color: rgba(0, 0, 0, 0.8) !important;
    -webkit-box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.35) inset, 0px 0px 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.35) inset, 0px 0px 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.basic.buttons .button:active,
.ui.basic.button:active {
    background: #F8F8F8 !important;
    color: rgba(0, 0, 0, 0.9) !important;
    -webkit-box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15) inset, 0px 1px 4px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15) inset, 0px 1px 4px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.basic.buttons .active.button,
.ui.basic.active.button {
    background: rgba(0, 0, 0, 0.05) !important;
    -webkit-box-shadow: '' !important;
    box-shadow: '' !important;
    color: rgba(0, 0, 0, 0.95) !important;
}
.ui.basic.buttons .active.button:hover,
.ui.basic.active.button:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

/* Vertical */
.ui.basic.buttons .button:hover {
    -webkit-box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.35) inset, 0px 0px 0px 0px rgba(34, 36, 38, 0.15) inset inset;
    box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.35) inset, 0px 0px 0px 0px rgba(34, 36, 38, 0.15) inset inset;
}
.ui.basic.buttons .button:active {
    -webkit-box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15) inset, 0px 1px 4px 0px rgba(34, 36, 38, 0.15) inset inset;
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15) inset, 0px 1px 4px 0px rgba(34, 36, 38, 0.15) inset inset;
}
.ui.basic.buttons .active.button {
    -webkit-box-shadow: '' !important;
    box-shadow: '' !important;
}

/* Standard Basic Inverted */
.ui.basic.inverted.buttons .button,
.ui.basic.inverted.button {
    background-color: transparent !important;
    color: #F9FAFB !important;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
}
.ui.basic.inverted.buttons .button:hover,
.ui.basic.inverted.button:hover {
    color: #FFFFFF !important;
    -webkit-box-shadow: 0px 0px 0px 2px #ffffff inset !important;
    box-shadow: 0px 0px 0px 2px #ffffff inset !important;
}
.ui.basic.inverted.buttons .button:focus,
.ui.basic.inverted.button:focus {
    color: #FFFFFF !important;
    -webkit-box-shadow: 0px 0px 0px 2px #ffffff inset !important;
    box-shadow: 0px 0px 0px 2px #ffffff inset !important;
}
.ui.basic.inverted.buttons .button:active,
.ui.basic.inverted.button:active {
    background-color: rgba(255, 255, 255, 0.08) !important;
    color: #FFFFFF !important;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.9) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.9) inset !important;
}
.ui.basic.inverted.buttons .active.button,
.ui.basic.inverted.active.button {
    background-color: rgba(255, 255, 255, 0.08);
    color: #FFFFFF;
    text-shadow: none;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.7) inset;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.7) inset;
}
.ui.basic.inverted.buttons .active.button:hover,
.ui.basic.inverted.active.button:hover {
    background-color: rgba(255, 255, 255, 0.15);
    -webkit-box-shadow: 0px 0px 0px 2px #ffffff inset !important;
    box-shadow: 0px 0px 0px 2px #ffffff inset !important;
}

/* Basic Group */
.ui.basic.buttons .button {
    border-left: 1px solid rgba(34, 36, 38, 0.15);
    -webkit-box-shadow: none;
    box-shadow: none;
}
.ui.basic.vertical.buttons .button {
    border-left: none;
}
.ui.basic.vertical.buttons .button {
    border-left-width: 0px;
    border-top: 1px solid rgba(34, 36, 38, 0.15);
}
.ui.basic.vertical.buttons .button:first-child {
    border-top-width: 0px;
}

/*--------------
  Labeled Icon
---------------*/

.ui.labeled.icon.buttons .button,
.ui.labeled.icon.button {
    position: relative;
    padding-left: 4.07142857em !important;
    padding-right: 1.5em !important;
}

/* Left Labeled */
.ui.labeled.icon.buttons > .button > .icon,
.ui.labeled.icon.button > .icon {
    position: absolute;
    height: 100%;
    line-height: 1;
    border-radius: 0px;
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
    text-align: center;
    margin: 0em;
    width: 2.57142857em;
    background-color: rgba(0, 0, 0, 0.05);
    color: '';
    -webkit-box-shadow: -1px 0px 0px 0px transparent inset;
    box-shadow: -1px 0px 0px 0px transparent inset;
}

/* Left Labeled */
.ui.labeled.icon.buttons > .button > .icon,
.ui.labeled.icon.button > .icon {
    top: 0em;
    left: 0em;
}

/* Right Labeled */
.ui[class*="right labeled"].icon.button {
    padding-right: 4.07142857em !important;
    padding-left: 1.5em !important;
}
.ui[class*="right labeled"].icon.button > .icon {
    left: auto;
    right: 0em;
    border-radius: 0px;
    border-top-right-radius: inherit;
    border-bottom-right-radius: inherit;
    -webkit-box-shadow: 1px 0px 0px 0px transparent inset;
    box-shadow: 1px 0px 0px 0px transparent inset;
}
.ui.labeled.icon.buttons > .button > .icon:before,
.ui.labeled.icon.button > .icon:before,
.ui.labeled.icon.buttons > .button > .icon:after,
.ui.labeled.icon.button > .icon:after {
    display: block;
    position: absolute;
    width: 100%;
    top: 50%;
    text-align: center;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}
.ui.labeled.icon.buttons .button > .icon {
    border-radius: 0em;
}
.ui.labeled.icon.buttons .button:first-child > .icon {
    border-top-left-radius: 0.28571429rem;
    border-bottom-left-radius: 0.28571429rem;
}
.ui.labeled.icon.buttons .button:last-child > .icon {
    border-top-right-radius: 0.28571429rem;
    border-bottom-right-radius: 0.28571429rem;
}
.ui.vertical.labeled.icon.buttons .button:first-child > .icon {
    border-radius: 0em;
    border-top-left-radius: 0.28571429rem;
}
.ui.vertical.labeled.icon.buttons .button:last-child > .icon {
    border-radius: 0em;
    border-bottom-left-radius: 0.28571429rem;
}

/* Fluid Labeled */
.ui.fluid[class*="left labeled"].icon.button,
.ui.fluid[class*="right labeled"].icon.button {
    padding-left: 1.5em !important;
    padding-right: 1.5em !important;
}

/*--------------
     Toggle
---------------*/


/* Toggle (Modifies active state to give affordances) */
.ui.toggle.buttons .active.button,
.ui.buttons .button.toggle.active,
.ui.button.toggle.active {
    background-color: #21BA45 !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    text-shadow: none;
    color: #FFFFFF !important;
}
.ui.button.toggle.active:hover {
    background-color: #16ab39 !important;
    text-shadow: none;
    color: #FFFFFF !important;
}

/*--------------
    Circular
---------------*/

.ui.circular.button {
    border-radius: 10em;
}
.ui.circular.button > .icon {
    width: 1em;
    vertical-align: baseline;
}

/*-------------------
      Or Buttons
--------------------*/

.ui.buttons .or {
    position: relative;
    width: 0.3em;
    height: 2.57142857em;
    z-index: 3;
}
.ui.buttons .or:before {
    position: absolute;
    text-align: center;
    border-radius: 500rem;
    content: 'or';
    top: 50%;
    left: 50%;
    background-color: #FFFFFF;
    text-shadow: none;
    margin-top: -0.89285714em;
    margin-left: -0.89285714em;
    width: 1.78571429em;
    height: 1.78571429em;
    line-height: 1.78571429em;
    color: rgba(0, 0, 0, 0.4);
    font-style: normal;
    font-weight: bold;
    -webkit-box-shadow: 0px 0px 0px 1px transparent inset;
    box-shadow: 0px 0px 0px 1px transparent inset;
}
.ui.buttons .or[data-text]:before {
    content: attr(data-text);
}

/* Fluid Or */
.ui.fluid.buttons .or {
    width: 0em !important;
}
.ui.fluid.buttons .or:after {
    display: none;
}

/*-------------------
       Attached
--------------------*/


/* Singular */
.ui.attached.button {
    position: relative;
    display: block;
    margin: 0em;
    border-radius: 0em;
    -webkit-box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.15) !important;
    box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.15) !important;
}

/* Top / Bottom */
.ui.attached.top.button {
    border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui.attached.bottom.button {
    border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}

/* Left / Right */
.ui.left.attached.button {
    display: inline-block;
    border-left: none;
    text-align: right;
    padding-right: 0.75em;
    border-radius: 0.28571429rem 0em 0em 0.28571429rem;
}
.ui.right.attached.button {
    display: inline-block;
    text-align: left;
    padding-left: 0.75em;
    border-radius: 0em 0.28571429rem 0.28571429rem 0em;
}

/* Plural */
.ui.attached.buttons {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border-radius: 0em;
    width: auto !important;
    z-index: 2;
    margin-left: -1px;
    margin-right: -1px;
}
.ui.attached.buttons .button {
    margin: 0em;
}
.ui.attached.buttons .button:first-child {
    border-radius: 0em;
}
.ui.attached.buttons .button:last-child {
    border-radius: 0em;
}

/* Top / Bottom */
.ui[class*="top attached"].buttons {
    margin-bottom: -1px;
    border-radius: 0.28571429rem 0.28571429rem 0em 0em;
}
.ui[class*="top attached"].buttons .button:first-child {
    border-radius: 0.28571429rem 0em 0em 0em;
}
.ui[class*="top attached"].buttons .button:last-child {
    border-radius: 0em 0.28571429rem 0em 0em;
}
.ui[class*="bottom attached"].buttons {
    margin-top: -1px;
    border-radius: 0em 0em 0.28571429rem 0.28571429rem;
}
.ui[class*="bottom attached"].buttons .button:first-child {
    border-radius: 0em 0em 0em 0.28571429rem;
}
.ui[class*="bottom attached"].buttons .button:last-child {
    border-radius: 0em 0em 0.28571429rem 0em;
}

/* Left / Right */
.ui[class*="left attached"].buttons {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    margin-right: 0em;
    margin-left: -1px;
    border-radius: 0em 0.28571429rem 0.28571429rem 0em;
}
.ui[class*="left attached"].buttons .button:first-child {
    margin-left: -1px;
    border-radius: 0em 0.28571429rem 0em 0em;
}
.ui[class*="left attached"].buttons .button:last-child {
    margin-left: -1px;
    border-radius: 0em 0em 0.28571429rem 0em;
}
.ui[class*="right attached"].buttons {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    margin-left: 0em;
    margin-right: -1px;
    border-radius: 0.28571429rem 0em 0em 0.28571429rem;
}
.ui[class*="right attached"].buttons .button:first-child {
    margin-left: -1px;
    border-radius: 0.28571429rem 0em 0em 0em;
}
.ui[class*="right attached"].buttons .button:last-child {
    margin-left: -1px;
    border-radius: 0em 0em 0em 0.28571429rem;
}

/*-------------------
        Fluid
--------------------*/

.ui.fluid.buttons,
.ui.fluid.button {
    width: 100%;
}
.ui.fluid.button {
    display: block;
}
.ui.two.buttons {
    width: 100%;
}
.ui.two.buttons > .button {
    width: 50%;
}
.ui.three.buttons {
    width: 100%;
}
.ui.three.buttons > .button {
    width: 33.333%;
}
.ui.four.buttons {
    width: 100%;
}
.ui.four.buttons > .button {
    width: 25%;
}
.ui.five.buttons {
    width: 100%;
}
.ui.five.buttons > .button {
    width: 20%;
}
.ui.six.buttons {
    width: 100%;
}
.ui.six.buttons > .button {
    width: 16.666%;
}
.ui.seven.buttons {
    width: 100%;
}
.ui.seven.buttons > .button {
    width: 14.285%;
}
.ui.eight.buttons {
    width: 100%;
}
.ui.eight.buttons > .button {
    width: 12.5%;
}
.ui.nine.buttons {
    width: 100%;
}
.ui.nine.buttons > .button {
    width: 11.11%;
}
.ui.ten.buttons {
    width: 100%;
}
.ui.ten.buttons > .button {
    width: 10%;
}
.ui.eleven.buttons {
    width: 100%;
}
.ui.eleven.buttons > .button {
    width: 9.09%;
}
.ui.twelve.buttons {
    width: 100%;
}
.ui.twelve.buttons > .button {
    width: 8.3333%;
}

/* Fluid Vertical Buttons */
.ui.fluid.vertical.buttons,
.ui.fluid.vertical.buttons > .button {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: auto;
}
.ui.two.vertical.buttons > .button {
    height: 50%;
}
.ui.three.vertical.buttons > .button {
    height: 33.333%;
}
.ui.four.vertical.buttons > .button {
    height: 25%;
}
.ui.five.vertical.buttons > .button {
    height: 20%;
}
.ui.six.vertical.buttons > .button {
    height: 16.666%;
}
.ui.seven.vertical.buttons > .button {
    height: 14.285%;
}
.ui.eight.vertical.buttons > .button {
    height: 12.5%;
}
.ui.nine.vertical.buttons > .button {
    height: 11.11%;
}
.ui.ten.vertical.buttons > .button {
    height: 10%;
}
.ui.eleven.vertical.buttons > .button {
    height: 9.09%;
}
.ui.twelve.vertical.buttons > .button {
    height: 8.3333%;
}

/*-------------------
       Colors
--------------------*/


/*--- Black ---*/

.ui.black.buttons .button,
.ui.black.button {
    background-color: #1B1C1D;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.black.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.black.buttons .button:hover,
.ui.black.button:hover {
    background-color: #27292a;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.black.buttons .button:focus,
.ui.black.button:focus {
    background-color: #2f3032;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.black.buttons .button:active,
.ui.black.button:active {
    background-color: #343637;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.black.buttons .active.button,
.ui.black.buttons .active.button:active,
.ui.black.active.button,
.ui.black.button .active.button:active {
    background-color: #0f0f10;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.black.buttons .button,
.ui.basic.black.button {
    -webkit-box-shadow: 0px 0px 0px 1px #1B1C1D inset !important;
    box-shadow: 0px 0px 0px 1px #1B1C1D inset !important;
    color: #1B1C1D !important;
}
.ui.basic.black.buttons .button:hover,
.ui.basic.black.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #27292a inset !important;
    box-shadow: 0px 0px 0px 1px #27292a inset !important;
    color: #27292a !important;
}
.ui.basic.black.buttons .button:focus,
.ui.basic.black.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #2f3032 inset !important;
    box-shadow: 0px 0px 0px 1px #2f3032 inset !important;
    color: #27292a !important;
}
.ui.basic.black.buttons .active.button,
.ui.basic.black.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #0f0f10 inset !important;
    box-shadow: 0px 0px 0px 1px #0f0f10 inset !important;
    color: #343637 !important;
}
.ui.basic.black.buttons .button:active,
.ui.basic.black.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #343637 inset !important;
    box-shadow: 0px 0px 0px 1px #343637 inset !important;
    color: #343637 !important;
}
.ui.buttons:not(.vertical) > .basic.black.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.black.buttons .button,
.ui.inverted.black.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #D4D4D5 inset !important;
    box-shadow: 0px 0px 0px 2px #D4D4D5 inset !important;
    color: #FFFFFF;
}
.ui.inverted.black.buttons .button:hover,
.ui.inverted.black.button:hover,
.ui.inverted.black.buttons .button:focus,
.ui.inverted.black.button:focus,
.ui.inverted.black.buttons .button.active,
.ui.inverted.black.button.active,
.ui.inverted.black.buttons .button:active,
.ui.inverted.black.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.black.buttons .button:hover,
.ui.inverted.black.button:hover {
    background-color: #000000;
}
.ui.inverted.black.buttons .button:focus,
.ui.inverted.black.button:focus {
    background-color: #000000;
}
.ui.inverted.black.buttons .active.button,
.ui.inverted.black.active.button {
    background-color: #000000;
}
.ui.inverted.black.buttons .button:active,
.ui.inverted.black.button:active {
    background-color: #000000;
}

/* Inverted Basic */
.ui.inverted.black.basic.buttons .button,
.ui.inverted.black.buttons .basic.button,
.ui.inverted.black.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.black.basic.buttons .button:hover,
.ui.inverted.black.buttons .basic.button:hover,
.ui.inverted.black.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #000000 inset !important;
    box-shadow: 0px 0px 0px 2px #000000 inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.black.basic.buttons .button:focus,
.ui.inverted.black.basic.buttons .button:focus,
.ui.inverted.black.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #000000 inset !important;
    box-shadow: 0px 0px 0px 2px #000000 inset !important;
    color: #545454 !important;
}
.ui.inverted.black.basic.buttons .active.button,
.ui.inverted.black.buttons .basic.active.button,
.ui.inverted.black.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #000000 inset !important;
    box-shadow: 0px 0px 0px 2px #000000 inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.black.basic.buttons .button:active,
.ui.inverted.black.buttons .basic.button:active,
.ui.inverted.black.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #000000 inset !important;
    box-shadow: 0px 0px 0px 2px #000000 inset !important;
    color: #FFFFFF !important;
}

/*--- Grey ---*/

.ui.grey.buttons .button,
.ui.grey.button {
    background-color: #767676;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.grey.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.grey.buttons .button:hover,
.ui.grey.button:hover {
    background-color: #838383;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.grey.buttons .button:focus,
.ui.grey.button:focus {
    background-color: #8a8a8a;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.grey.buttons .button:active,
.ui.grey.button:active {
    background-color: #909090;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.grey.buttons .active.button,
.ui.grey.buttons .active.button:active,
.ui.grey.active.button,
.ui.grey.button .active.button:active {
    background-color: #696969;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.grey.buttons .button,
.ui.basic.grey.button {
    -webkit-box-shadow: 0px 0px 0px 1px #767676 inset !important;
    box-shadow: 0px 0px 0px 1px #767676 inset !important;
    color: #767676 !important;
}
.ui.basic.grey.buttons .button:hover,
.ui.basic.grey.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #838383 inset !important;
    box-shadow: 0px 0px 0px 1px #838383 inset !important;
    color: #838383 !important;
}
.ui.basic.grey.buttons .button:focus,
.ui.basic.grey.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #8a8a8a inset !important;
    box-shadow: 0px 0px 0px 1px #8a8a8a inset !important;
    color: #838383 !important;
}
.ui.basic.grey.buttons .active.button,
.ui.basic.grey.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #696969 inset !important;
    box-shadow: 0px 0px 0px 1px #696969 inset !important;
    color: #909090 !important;
}
.ui.basic.grey.buttons .button:active,
.ui.basic.grey.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #909090 inset !important;
    box-shadow: 0px 0px 0px 1px #909090 inset !important;
    color: #909090 !important;
}
.ui.buttons:not(.vertical) > .basic.grey.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.grey.buttons .button,
.ui.inverted.grey.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #D4D4D5 inset !important;
    box-shadow: 0px 0px 0px 2px #D4D4D5 inset !important;
    color: #FFFFFF;
}
.ui.inverted.grey.buttons .button:hover,
.ui.inverted.grey.button:hover,
.ui.inverted.grey.buttons .button:focus,
.ui.inverted.grey.button:focus,
.ui.inverted.grey.buttons .button.active,
.ui.inverted.grey.button.active,
.ui.inverted.grey.buttons .button:active,
.ui.inverted.grey.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: rgba(0, 0, 0, 0.6);
}
.ui.inverted.grey.buttons .button:hover,
.ui.inverted.grey.button:hover {
    background-color: #cfd0d2;
}
.ui.inverted.grey.buttons .button:focus,
.ui.inverted.grey.button:focus {
    background-color: #c7c9cb;
}
.ui.inverted.grey.buttons .active.button,
.ui.inverted.grey.active.button {
    background-color: #cfd0d2;
}
.ui.inverted.grey.buttons .button:active,
.ui.inverted.grey.button:active {
    background-color: #c2c4c5;
}

/* Inverted Basic */
.ui.inverted.grey.basic.buttons .button,
.ui.inverted.grey.buttons .basic.button,
.ui.inverted.grey.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.grey.basic.buttons .button:hover,
.ui.inverted.grey.buttons .basic.button:hover,
.ui.inverted.grey.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #cfd0d2 inset !important;
    box-shadow: 0px 0px 0px 2px #cfd0d2 inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.grey.basic.buttons .button:focus,
.ui.inverted.grey.basic.buttons .button:focus,
.ui.inverted.grey.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #c7c9cb inset !important;
    box-shadow: 0px 0px 0px 2px #c7c9cb inset !important;
    color: #DCDDDE !important;
}
.ui.inverted.grey.basic.buttons .active.button,
.ui.inverted.grey.buttons .basic.active.button,
.ui.inverted.grey.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #cfd0d2 inset !important;
    box-shadow: 0px 0px 0px 2px #cfd0d2 inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.grey.basic.buttons .button:active,
.ui.inverted.grey.buttons .basic.button:active,
.ui.inverted.grey.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #c2c4c5 inset !important;
    box-shadow: 0px 0px 0px 2px #c2c4c5 inset !important;
    color: #FFFFFF !important;
}

/*--- Brown ---*/

.ui.brown.buttons .button,
.ui.brown.button {
    background-color: #A5673F;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.brown.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.brown.buttons .button:hover,
.ui.brown.button:hover {
    background-color: #975b33;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.brown.buttons .button:focus,
.ui.brown.button:focus {
    background-color: #90532b;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.brown.buttons .button:active,
.ui.brown.button:active {
    background-color: #805031;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.brown.buttons .active.button,
.ui.brown.buttons .active.button:active,
.ui.brown.active.button,
.ui.brown.button .active.button:active {
    background-color: #995a31;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.brown.buttons .button,
.ui.basic.brown.button {
    -webkit-box-shadow: 0px 0px 0px 1px #A5673F inset !important;
    box-shadow: 0px 0px 0px 1px #A5673F inset !important;
    color: #A5673F !important;
}
.ui.basic.brown.buttons .button:hover,
.ui.basic.brown.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #975b33 inset !important;
    box-shadow: 0px 0px 0px 1px #975b33 inset !important;
    color: #975b33 !important;
}
.ui.basic.brown.buttons .button:focus,
.ui.basic.brown.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #90532b inset !important;
    box-shadow: 0px 0px 0px 1px #90532b inset !important;
    color: #975b33 !important;
}
.ui.basic.brown.buttons .active.button,
.ui.basic.brown.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #995a31 inset !important;
    box-shadow: 0px 0px 0px 1px #995a31 inset !important;
    color: #805031 !important;
}
.ui.basic.brown.buttons .button:active,
.ui.basic.brown.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #805031 inset !important;
    box-shadow: 0px 0px 0px 1px #805031 inset !important;
    color: #805031 !important;
}
.ui.buttons:not(.vertical) > .basic.brown.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.brown.buttons .button,
.ui.inverted.brown.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #D67C1C inset !important;
    box-shadow: 0px 0px 0px 2px #D67C1C inset !important;
    color: #D67C1C;
}
.ui.inverted.brown.buttons .button:hover,
.ui.inverted.brown.button:hover,
.ui.inverted.brown.buttons .button:focus,
.ui.inverted.brown.button:focus,
.ui.inverted.brown.buttons .button.active,
.ui.inverted.brown.button.active,
.ui.inverted.brown.buttons .button:active,
.ui.inverted.brown.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.brown.buttons .button:hover,
.ui.inverted.brown.button:hover {
    background-color: #c86f11;
}
.ui.inverted.brown.buttons .button:focus,
.ui.inverted.brown.button:focus {
    background-color: #c16808;
}
.ui.inverted.brown.buttons .active.button,
.ui.inverted.brown.active.button {
    background-color: #cc6f0d;
}
.ui.inverted.brown.buttons .button:active,
.ui.inverted.brown.button:active {
    background-color: #a96216;
}

/* Inverted Basic */
.ui.inverted.brown.basic.buttons .button,
.ui.inverted.brown.buttons .basic.button,
.ui.inverted.brown.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.brown.basic.buttons .button:hover,
.ui.inverted.brown.buttons .basic.button:hover,
.ui.inverted.brown.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #c86f11 inset !important;
    box-shadow: 0px 0px 0px 2px #c86f11 inset !important;
    color: #D67C1C !important;
}
.ui.inverted.brown.basic.buttons .button:focus,
.ui.inverted.brown.basic.buttons .button:focus,
.ui.inverted.brown.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #c16808 inset !important;
    box-shadow: 0px 0px 0px 2px #c16808 inset !important;
    color: #D67C1C !important;
}
.ui.inverted.brown.basic.buttons .active.button,
.ui.inverted.brown.buttons .basic.active.button,
.ui.inverted.brown.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #cc6f0d inset !important;
    box-shadow: 0px 0px 0px 2px #cc6f0d inset !important;
    color: #D67C1C !important;
}
.ui.inverted.brown.basic.buttons .button:active,
.ui.inverted.brown.buttons .basic.button:active,
.ui.inverted.brown.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #a96216 inset !important;
    box-shadow: 0px 0px 0px 2px #a96216 inset !important;
    color: #D67C1C !important;
}

/*--- Blue ---*/

.ui.blue.buttons .button,
.ui.blue.button {
    background-color: #2185D0;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.blue.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.blue.buttons .button:hover,
.ui.blue.button:hover {
    background-color: #1678c2;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.blue.buttons .button:focus,
.ui.blue.button:focus {
    background-color: #0d71bb;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.blue.buttons .button:active,
.ui.blue.button:active {
    background-color: #1a69a4;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.blue.buttons .active.button,
.ui.blue.buttons .active.button:active,
.ui.blue.active.button,
.ui.blue.button .active.button:active {
    background-color: #1279c6;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.blue.buttons .button,
.ui.basic.blue.button {
    -webkit-box-shadow: 0px 0px 0px 1px #2185D0 inset !important;
    box-shadow: 0px 0px 0px 1px #2185D0 inset !important;
    color: #2185D0 !important;
}
.ui.basic.blue.buttons .button:hover,
.ui.basic.blue.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #1678c2 inset !important;
    box-shadow: 0px 0px 0px 1px #1678c2 inset !important;
    color: #1678c2 !important;
}
.ui.basic.blue.buttons .button:focus,
.ui.basic.blue.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #0d71bb inset !important;
    box-shadow: 0px 0px 0px 1px #0d71bb inset !important;
    color: #1678c2 !important;
}
.ui.basic.blue.buttons .active.button,
.ui.basic.blue.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #1279c6 inset !important;
    box-shadow: 0px 0px 0px 1px #1279c6 inset !important;
    color: #1a69a4 !important;
}
.ui.basic.blue.buttons .button:active,
.ui.basic.blue.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #1a69a4 inset !important;
    box-shadow: 0px 0px 0px 1px #1a69a4 inset !important;
    color: #1a69a4 !important;
}
.ui.buttons:not(.vertical) > .basic.blue.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.blue.buttons .button,
.ui.inverted.blue.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #54C8FF inset !important;
    box-shadow: 0px 0px 0px 2px #54C8FF inset !important;
    color: #54C8FF;
}
.ui.inverted.blue.buttons .button:hover,
.ui.inverted.blue.button:hover,
.ui.inverted.blue.buttons .button:focus,
.ui.inverted.blue.button:focus,
.ui.inverted.blue.buttons .button.active,
.ui.inverted.blue.button.active,
.ui.inverted.blue.buttons .button:active,
.ui.inverted.blue.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.blue.buttons .button:hover,
.ui.inverted.blue.button:hover {
    background-color: #3ac0ff;
}
.ui.inverted.blue.buttons .button:focus,
.ui.inverted.blue.button:focus {
    background-color: #2bbbff;
}
.ui.inverted.blue.buttons .active.button,
.ui.inverted.blue.active.button {
    background-color: #3ac0ff;
}
.ui.inverted.blue.buttons .button:active,
.ui.inverted.blue.button:active {
    background-color: #21b8ff;
}

/* Inverted Basic */
.ui.inverted.blue.basic.buttons .button,
.ui.inverted.blue.buttons .basic.button,
.ui.inverted.blue.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.blue.basic.buttons .button:hover,
.ui.inverted.blue.buttons .basic.button:hover,
.ui.inverted.blue.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
    box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
    color: #54C8FF !important;
}
.ui.inverted.blue.basic.buttons .button:focus,
.ui.inverted.blue.basic.buttons .button:focus,
.ui.inverted.blue.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #2bbbff inset !important;
    box-shadow: 0px 0px 0px 2px #2bbbff inset !important;
    color: #54C8FF !important;
}
.ui.inverted.blue.basic.buttons .active.button,
.ui.inverted.blue.buttons .basic.active.button,
.ui.inverted.blue.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
    box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
    color: #54C8FF !important;
}
.ui.inverted.blue.basic.buttons .button:active,
.ui.inverted.blue.buttons .basic.button:active,
.ui.inverted.blue.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #21b8ff inset !important;
    box-shadow: 0px 0px 0px 2px #21b8ff inset !important;
    color: #54C8FF !important;
}

/*--- Green ---*/

.ui.green.buttons .button,
.ui.green.button {
    background-color: #21BA45;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.green.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.green.buttons .button:hover,
.ui.green.button:hover {
    background-color: #16ab39;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.green.buttons .button:focus,
.ui.green.button:focus {
    background-color: #0ea432;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.green.buttons .button:active,
.ui.green.button:active {
    background-color: #198f35;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.green.buttons .active.button,
.ui.green.buttons .active.button:active,
.ui.green.active.button,
.ui.green.button .active.button:active {
    background-color: #13ae38;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.green.buttons .button,
.ui.basic.green.button {
    -webkit-box-shadow: 0px 0px 0px 1px #21BA45 inset !important;
    box-shadow: 0px 0px 0px 1px #21BA45 inset !important;
    color: #21BA45 !important;
}
.ui.basic.green.buttons .button:hover,
.ui.basic.green.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #16ab39 inset !important;
    box-shadow: 0px 0px 0px 1px #16ab39 inset !important;
    color: #16ab39 !important;
}
.ui.basic.green.buttons .button:focus,
.ui.basic.green.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #0ea432 inset !important;
    box-shadow: 0px 0px 0px 1px #0ea432 inset !important;
    color: #16ab39 !important;
}
.ui.basic.green.buttons .active.button,
.ui.basic.green.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #13ae38 inset !important;
    box-shadow: 0px 0px 0px 1px #13ae38 inset !important;
    color: #198f35 !important;
}
.ui.basic.green.buttons .button:active,
.ui.basic.green.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #198f35 inset !important;
    box-shadow: 0px 0px 0px 1px #198f35 inset !important;
    color: #198f35 !important;
}
.ui.buttons:not(.vertical) > .basic.green.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.green.buttons .button,
.ui.inverted.green.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #2ECC40 inset !important;
    box-shadow: 0px 0px 0px 2px #2ECC40 inset !important;
    color: #2ECC40;
}
.ui.inverted.green.buttons .button:hover,
.ui.inverted.green.button:hover,
.ui.inverted.green.buttons .button:focus,
.ui.inverted.green.button:focus,
.ui.inverted.green.buttons .button.active,
.ui.inverted.green.button.active,
.ui.inverted.green.buttons .button:active,
.ui.inverted.green.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.green.buttons .button:hover,
.ui.inverted.green.button:hover {
    background-color: #22be34;
}
.ui.inverted.green.buttons .button:focus,
.ui.inverted.green.button:focus {
    background-color: #19b82b;
}
.ui.inverted.green.buttons .active.button,
.ui.inverted.green.active.button {
    background-color: #1fc231;
}
.ui.inverted.green.buttons .button:active,
.ui.inverted.green.button:active {
    background-color: #25a233;
}

/* Inverted Basic */
.ui.inverted.green.basic.buttons .button,
.ui.inverted.green.buttons .basic.button,
.ui.inverted.green.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.green.basic.buttons .button:hover,
.ui.inverted.green.buttons .basic.button:hover,
.ui.inverted.green.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #22be34 inset !important;
    box-shadow: 0px 0px 0px 2px #22be34 inset !important;
    color: #2ECC40 !important;
}
.ui.inverted.green.basic.buttons .button:focus,
.ui.inverted.green.basic.buttons .button:focus,
.ui.inverted.green.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #19b82b inset !important;
    box-shadow: 0px 0px 0px 2px #19b82b inset !important;
    color: #2ECC40 !important;
}
.ui.inverted.green.basic.buttons .active.button,
.ui.inverted.green.buttons .basic.active.button,
.ui.inverted.green.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #1fc231 inset !important;
    box-shadow: 0px 0px 0px 2px #1fc231 inset !important;
    color: #2ECC40 !important;
}
.ui.inverted.green.basic.buttons .button:active,
.ui.inverted.green.buttons .basic.button:active,
.ui.inverted.green.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #25a233 inset !important;
    box-shadow: 0px 0px 0px 2px #25a233 inset !important;
    color: #2ECC40 !important;
}

/*--- Orange ---*/

.ui.orange.buttons .button,
.ui.orange.button {
    background-color: #F2711C;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.orange.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.orange.buttons .button:hover,
.ui.orange.button:hover {
    background-color: #f26202;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.orange.buttons .button:focus,
.ui.orange.button:focus {
    background-color: #e55b00;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.orange.buttons .button:active,
.ui.orange.button:active {
    background-color: #cf590c;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.orange.buttons .active.button,
.ui.orange.buttons .active.button:active,
.ui.orange.active.button,
.ui.orange.button .active.button:active {
    background-color: #f56100;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.orange.buttons .button,
.ui.basic.orange.button {
    -webkit-box-shadow: 0px 0px 0px 1px #F2711C inset !important;
    box-shadow: 0px 0px 0px 1px #F2711C inset !important;
    color: #F2711C !important;
}
.ui.basic.orange.buttons .button:hover,
.ui.basic.orange.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #f26202 inset !important;
    box-shadow: 0px 0px 0px 1px #f26202 inset !important;
    color: #f26202 !important;
}
.ui.basic.orange.buttons .button:focus,
.ui.basic.orange.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #e55b00 inset !important;
    box-shadow: 0px 0px 0px 1px #e55b00 inset !important;
    color: #f26202 !important;
}
.ui.basic.orange.buttons .active.button,
.ui.basic.orange.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #f56100 inset !important;
    box-shadow: 0px 0px 0px 1px #f56100 inset !important;
    color: #cf590c !important;
}
.ui.basic.orange.buttons .button:active,
.ui.basic.orange.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #cf590c inset !important;
    box-shadow: 0px 0px 0px 1px #cf590c inset !important;
    color: #cf590c !important;
}
.ui.buttons:not(.vertical) > .basic.orange.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.orange.buttons .button,
.ui.inverted.orange.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #FF851B inset !important;
    box-shadow: 0px 0px 0px 2px #FF851B inset !important;
    color: #FF851B;
}
.ui.inverted.orange.buttons .button:hover,
.ui.inverted.orange.button:hover,
.ui.inverted.orange.buttons .button:focus,
.ui.inverted.orange.button:focus,
.ui.inverted.orange.buttons .button.active,
.ui.inverted.orange.button.active,
.ui.inverted.orange.buttons .button:active,
.ui.inverted.orange.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.orange.buttons .button:hover,
.ui.inverted.orange.button:hover {
    background-color: #ff7701;
}
.ui.inverted.orange.buttons .button:focus,
.ui.inverted.orange.button:focus {
    background-color: #f17000;
}
.ui.inverted.orange.buttons .active.button,
.ui.inverted.orange.active.button {
    background-color: #ff7701;
}
.ui.inverted.orange.buttons .button:active,
.ui.inverted.orange.button:active {
    background-color: #e76b00;
}

/* Inverted Basic */
.ui.inverted.orange.basic.buttons .button,
.ui.inverted.orange.buttons .basic.button,
.ui.inverted.orange.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.orange.basic.buttons .button:hover,
.ui.inverted.orange.buttons .basic.button:hover,
.ui.inverted.orange.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #ff7701 inset !important;
    box-shadow: 0px 0px 0px 2px #ff7701 inset !important;
    color: #FF851B !important;
}
.ui.inverted.orange.basic.buttons .button:focus,
.ui.inverted.orange.basic.buttons .button:focus,
.ui.inverted.orange.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #f17000 inset !important;
    box-shadow: 0px 0px 0px 2px #f17000 inset !important;
    color: #FF851B !important;
}
.ui.inverted.orange.basic.buttons .active.button,
.ui.inverted.orange.buttons .basic.active.button,
.ui.inverted.orange.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #ff7701 inset !important;
    box-shadow: 0px 0px 0px 2px #ff7701 inset !important;
    color: #FF851B !important;
}
.ui.inverted.orange.basic.buttons .button:active,
.ui.inverted.orange.buttons .basic.button:active,
.ui.inverted.orange.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #e76b00 inset !important;
    box-shadow: 0px 0px 0px 2px #e76b00 inset !important;
    color: #FF851B !important;
}

/*--- Pink ---*/

.ui.pink.buttons .button,
.ui.pink.button {
    background-color: #E03997;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.pink.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.pink.buttons .button:hover,
.ui.pink.button:hover {
    background-color: #e61a8d;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.pink.buttons .button:focus,
.ui.pink.button:focus {
    background-color: #e10f85;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.pink.buttons .button:active,
.ui.pink.button:active {
    background-color: #c71f7e;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.pink.buttons .active.button,
.ui.pink.buttons .active.button:active,
.ui.pink.active.button,
.ui.pink.button .active.button:active {
    background-color: #ea158d;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.pink.buttons .button,
.ui.basic.pink.button {
    -webkit-box-shadow: 0px 0px 0px 1px #E03997 inset !important;
    box-shadow: 0px 0px 0px 1px #E03997 inset !important;
    color: #E03997 !important;
}
.ui.basic.pink.buttons .button:hover,
.ui.basic.pink.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #e61a8d inset !important;
    box-shadow: 0px 0px 0px 1px #e61a8d inset !important;
    color: #e61a8d !important;
}
.ui.basic.pink.buttons .button:focus,
.ui.basic.pink.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #e10f85 inset !important;
    box-shadow: 0px 0px 0px 1px #e10f85 inset !important;
    color: #e61a8d !important;
}
.ui.basic.pink.buttons .active.button,
.ui.basic.pink.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #ea158d inset !important;
    box-shadow: 0px 0px 0px 1px #ea158d inset !important;
    color: #c71f7e !important;
}
.ui.basic.pink.buttons .button:active,
.ui.basic.pink.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #c71f7e inset !important;
    box-shadow: 0px 0px 0px 1px #c71f7e inset !important;
    color: #c71f7e !important;
}
.ui.buttons:not(.vertical) > .basic.pink.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.pink.buttons .button,
.ui.inverted.pink.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #FF8EDF inset !important;
    box-shadow: 0px 0px 0px 2px #FF8EDF inset !important;
    color: #FF8EDF;
}
.ui.inverted.pink.buttons .button:hover,
.ui.inverted.pink.button:hover,
.ui.inverted.pink.buttons .button:focus,
.ui.inverted.pink.button:focus,
.ui.inverted.pink.buttons .button.active,
.ui.inverted.pink.button.active,
.ui.inverted.pink.buttons .button:active,
.ui.inverted.pink.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.pink.buttons .button:hover,
.ui.inverted.pink.button:hover {
    background-color: #ff74d8;
}
.ui.inverted.pink.buttons .button:focus,
.ui.inverted.pink.button:focus {
    background-color: #ff65d3;
}
.ui.inverted.pink.buttons .active.button,
.ui.inverted.pink.active.button {
    background-color: #ff74d8;
}
.ui.inverted.pink.buttons .button:active,
.ui.inverted.pink.button:active {
    background-color: #ff5bd1;
}

/* Inverted Basic */
.ui.inverted.pink.basic.buttons .button,
.ui.inverted.pink.buttons .basic.button,
.ui.inverted.pink.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.pink.basic.buttons .button:hover,
.ui.inverted.pink.buttons .basic.button:hover,
.ui.inverted.pink.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #ff74d8 inset !important;
    box-shadow: 0px 0px 0px 2px #ff74d8 inset !important;
    color: #FF8EDF !important;
}
.ui.inverted.pink.basic.buttons .button:focus,
.ui.inverted.pink.basic.buttons .button:focus,
.ui.inverted.pink.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #ff65d3 inset !important;
    box-shadow: 0px 0px 0px 2px #ff65d3 inset !important;
    color: #FF8EDF !important;
}
.ui.inverted.pink.basic.buttons .active.button,
.ui.inverted.pink.buttons .basic.active.button,
.ui.inverted.pink.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #ff74d8 inset !important;
    box-shadow: 0px 0px 0px 2px #ff74d8 inset !important;
    color: #FF8EDF !important;
}
.ui.inverted.pink.basic.buttons .button:active,
.ui.inverted.pink.buttons .basic.button:active,
.ui.inverted.pink.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #ff5bd1 inset !important;
    box-shadow: 0px 0px 0px 2px #ff5bd1 inset !important;
    color: #FF8EDF !important;
}

/*--- Violet ---*/

.ui.violet.buttons .button,
.ui.violet.button {
    background-color: #6435C9;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.violet.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.violet.buttons .button:hover,
.ui.violet.button:hover {
    background-color: #5829bb;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.violet.buttons .button:focus,
.ui.violet.button:focus {
    background-color: #4f20b5;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.violet.buttons .button:active,
.ui.violet.button:active {
    background-color: #502aa1;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.violet.buttons .active.button,
.ui.violet.buttons .active.button:active,
.ui.violet.active.button,
.ui.violet.button .active.button:active {
    background-color: #5626bf;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.violet.buttons .button,
.ui.basic.violet.button {
    -webkit-box-shadow: 0px 0px 0px 1px #6435C9 inset !important;
    box-shadow: 0px 0px 0px 1px #6435C9 inset !important;
    color: #6435C9 !important;
}
.ui.basic.violet.buttons .button:hover,
.ui.basic.violet.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #5829bb inset !important;
    box-shadow: 0px 0px 0px 1px #5829bb inset !important;
    color: #5829bb !important;
}
.ui.basic.violet.buttons .button:focus,
.ui.basic.violet.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #4f20b5 inset !important;
    box-shadow: 0px 0px 0px 1px #4f20b5 inset !important;
    color: #5829bb !important;
}
.ui.basic.violet.buttons .active.button,
.ui.basic.violet.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #5626bf inset !important;
    box-shadow: 0px 0px 0px 1px #5626bf inset !important;
    color: #502aa1 !important;
}
.ui.basic.violet.buttons .button:active,
.ui.basic.violet.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #502aa1 inset !important;
    box-shadow: 0px 0px 0px 1px #502aa1 inset !important;
    color: #502aa1 !important;
}
.ui.buttons:not(.vertical) > .basic.violet.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.violet.buttons .button,
.ui.inverted.violet.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #A291FB inset !important;
    box-shadow: 0px 0px 0px 2px #A291FB inset !important;
    color: #A291FB;
}
.ui.inverted.violet.buttons .button:hover,
.ui.inverted.violet.button:hover,
.ui.inverted.violet.buttons .button:focus,
.ui.inverted.violet.button:focus,
.ui.inverted.violet.buttons .button.active,
.ui.inverted.violet.button.active,
.ui.inverted.violet.buttons .button:active,
.ui.inverted.violet.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.violet.buttons .button:hover,
.ui.inverted.violet.button:hover {
    background-color: #8a73ff;
}
.ui.inverted.violet.buttons .button:focus,
.ui.inverted.violet.button:focus {
    background-color: #7d64ff;
}
.ui.inverted.violet.buttons .active.button,
.ui.inverted.violet.active.button {
    background-color: #8a73ff;
}
.ui.inverted.violet.buttons .button:active,
.ui.inverted.violet.button:active {
    background-color: #7860f9;
}

/* Inverted Basic */
.ui.inverted.violet.basic.buttons .button,
.ui.inverted.violet.buttons .basic.button,
.ui.inverted.violet.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.violet.basic.buttons .button:hover,
.ui.inverted.violet.buttons .basic.button:hover,
.ui.inverted.violet.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #8a73ff inset !important;
    box-shadow: 0px 0px 0px 2px #8a73ff inset !important;
    color: #A291FB !important;
}
.ui.inverted.violet.basic.buttons .button:focus,
.ui.inverted.violet.basic.buttons .button:focus,
.ui.inverted.violet.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #7d64ff inset !important;
    box-shadow: 0px 0px 0px 2px #7d64ff inset !important;
    color: #A291FB !important;
}
.ui.inverted.violet.basic.buttons .active.button,
.ui.inverted.violet.buttons .basic.active.button,
.ui.inverted.violet.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #8a73ff inset !important;
    box-shadow: 0px 0px 0px 2px #8a73ff inset !important;
    color: #A291FB !important;
}
.ui.inverted.violet.basic.buttons .button:active,
.ui.inverted.violet.buttons .basic.button:active,
.ui.inverted.violet.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #7860f9 inset !important;
    box-shadow: 0px 0px 0px 2px #7860f9 inset !important;
    color: #A291FB !important;
}

/*--- Purple ---*/

.ui.purple.buttons .button,
.ui.purple.button {
    background-color: #A333C8;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.purple.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.purple.buttons .button:hover,
.ui.purple.button:hover {
    background-color: #9627ba;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.purple.buttons .button:focus,
.ui.purple.button:focus {
    background-color: #8f1eb4;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.purple.buttons .button:active,
.ui.purple.button:active {
    background-color: #82299f;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.purple.buttons .active.button,
.ui.purple.buttons .active.button:active,
.ui.purple.active.button,
.ui.purple.button .active.button:active {
    background-color: #9724be;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.purple.buttons .button,
.ui.basic.purple.button {
    -webkit-box-shadow: 0px 0px 0px 1px #A333C8 inset !important;
    box-shadow: 0px 0px 0px 1px #A333C8 inset !important;
    color: #A333C8 !important;
}
.ui.basic.purple.buttons .button:hover,
.ui.basic.purple.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #9627ba inset !important;
    box-shadow: 0px 0px 0px 1px #9627ba inset !important;
    color: #9627ba !important;
}
.ui.basic.purple.buttons .button:focus,
.ui.basic.purple.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #8f1eb4 inset !important;
    box-shadow: 0px 0px 0px 1px #8f1eb4 inset !important;
    color: #9627ba !important;
}
.ui.basic.purple.buttons .active.button,
.ui.basic.purple.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #9724be inset !important;
    box-shadow: 0px 0px 0px 1px #9724be inset !important;
    color: #82299f !important;
}
.ui.basic.purple.buttons .button:active,
.ui.basic.purple.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #82299f inset !important;
    box-shadow: 0px 0px 0px 1px #82299f inset !important;
    color: #82299f !important;
}
.ui.buttons:not(.vertical) > .basic.purple.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.purple.buttons .button,
.ui.inverted.purple.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #DC73FF inset !important;
    box-shadow: 0px 0px 0px 2px #DC73FF inset !important;
    color: #DC73FF;
}
.ui.inverted.purple.buttons .button:hover,
.ui.inverted.purple.button:hover,
.ui.inverted.purple.buttons .button:focus,
.ui.inverted.purple.button:focus,
.ui.inverted.purple.buttons .button.active,
.ui.inverted.purple.button.active,
.ui.inverted.purple.buttons .button:active,
.ui.inverted.purple.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.purple.buttons .button:hover,
.ui.inverted.purple.button:hover {
    background-color: #d65aff;
}
.ui.inverted.purple.buttons .button:focus,
.ui.inverted.purple.button:focus {
    background-color: #d24aff;
}
.ui.inverted.purple.buttons .active.button,
.ui.inverted.purple.active.button {
    background-color: #d65aff;
}
.ui.inverted.purple.buttons .button:active,
.ui.inverted.purple.button:active {
    background-color: #cf40ff;
}

/* Inverted Basic */
.ui.inverted.purple.basic.buttons .button,
.ui.inverted.purple.buttons .basic.button,
.ui.inverted.purple.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.purple.basic.buttons .button:hover,
.ui.inverted.purple.buttons .basic.button:hover,
.ui.inverted.purple.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #d65aff inset !important;
    box-shadow: 0px 0px 0px 2px #d65aff inset !important;
    color: #DC73FF !important;
}
.ui.inverted.purple.basic.buttons .button:focus,
.ui.inverted.purple.basic.buttons .button:focus,
.ui.inverted.purple.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #d24aff inset !important;
    box-shadow: 0px 0px 0px 2px #d24aff inset !important;
    color: #DC73FF !important;
}
.ui.inverted.purple.basic.buttons .active.button,
.ui.inverted.purple.buttons .basic.active.button,
.ui.inverted.purple.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #d65aff inset !important;
    box-shadow: 0px 0px 0px 2px #d65aff inset !important;
    color: #DC73FF !important;
}
.ui.inverted.purple.basic.buttons .button:active,
.ui.inverted.purple.buttons .basic.button:active,
.ui.inverted.purple.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #cf40ff inset !important;
    box-shadow: 0px 0px 0px 2px #cf40ff inset !important;
    color: #DC73FF !important;
}

/*--- Red ---*/

.ui.red.buttons .button,
.ui.red.button {
    background-color: #DB2828;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.red.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.red.buttons .button:hover,
.ui.red.button:hover {
    background-color: #d01919;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.red.buttons .button:focus,
.ui.red.button:focus {
    background-color: #ca1010;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.red.buttons .button:active,
.ui.red.button:active {
    background-color: #b21e1e;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.red.buttons .active.button,
.ui.red.buttons .active.button:active,
.ui.red.active.button,
.ui.red.button .active.button:active {
    background-color: #d41515;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.red.buttons .button,
.ui.basic.red.button {
    -webkit-box-shadow: 0px 0px 0px 1px #DB2828 inset !important;
    box-shadow: 0px 0px 0px 1px #DB2828 inset !important;
    color: #DB2828 !important;
}
.ui.basic.red.buttons .button:hover,
.ui.basic.red.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #d01919 inset !important;
    box-shadow: 0px 0px 0px 1px #d01919 inset !important;
    color: #d01919 !important;
}
.ui.basic.red.buttons .button:focus,
.ui.basic.red.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #ca1010 inset !important;
    box-shadow: 0px 0px 0px 1px #ca1010 inset !important;
    color: #d01919 !important;
}
.ui.basic.red.buttons .active.button,
.ui.basic.red.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #d41515 inset !important;
    box-shadow: 0px 0px 0px 1px #d41515 inset !important;
    color: #b21e1e !important;
}
.ui.basic.red.buttons .button:active,
.ui.basic.red.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #b21e1e inset !important;
    box-shadow: 0px 0px 0px 1px #b21e1e inset !important;
    color: #b21e1e !important;
}
.ui.buttons:not(.vertical) > .basic.red.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.red.buttons .button,
.ui.inverted.red.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #FF695E inset !important;
    box-shadow: 0px 0px 0px 2px #FF695E inset !important;
    color: #FF695E;
}
.ui.inverted.red.buttons .button:hover,
.ui.inverted.red.button:hover,
.ui.inverted.red.buttons .button:focus,
.ui.inverted.red.button:focus,
.ui.inverted.red.buttons .button.active,
.ui.inverted.red.button.active,
.ui.inverted.red.buttons .button:active,
.ui.inverted.red.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.red.buttons .button:hover,
.ui.inverted.red.button:hover {
    background-color: #ff5144;
}
.ui.inverted.red.buttons .button:focus,
.ui.inverted.red.button:focus {
    background-color: #ff4335;
}
.ui.inverted.red.buttons .active.button,
.ui.inverted.red.active.button {
    background-color: #ff5144;
}
.ui.inverted.red.buttons .button:active,
.ui.inverted.red.button:active {
    background-color: #ff392b;
}

/* Inverted Basic */
.ui.inverted.red.basic.buttons .button,
.ui.inverted.red.buttons .basic.button,
.ui.inverted.red.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.red.basic.buttons .button:hover,
.ui.inverted.red.buttons .basic.button:hover,
.ui.inverted.red.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #ff5144 inset !important;
    box-shadow: 0px 0px 0px 2px #ff5144 inset !important;
    color: #FF695E !important;
}
.ui.inverted.red.basic.buttons .button:focus,
.ui.inverted.red.basic.buttons .button:focus,
.ui.inverted.red.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #ff4335 inset !important;
    box-shadow: 0px 0px 0px 2px #ff4335 inset !important;
    color: #FF695E !important;
}
.ui.inverted.red.basic.buttons .active.button,
.ui.inverted.red.buttons .basic.active.button,
.ui.inverted.red.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #ff5144 inset !important;
    box-shadow: 0px 0px 0px 2px #ff5144 inset !important;
    color: #FF695E !important;
}
.ui.inverted.red.basic.buttons .button:active,
.ui.inverted.red.buttons .basic.button:active,
.ui.inverted.red.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #ff392b inset !important;
    box-shadow: 0px 0px 0px 2px #ff392b inset !important;
    color: #FF695E !important;
}

/*--- Teal ---*/

.ui.teal.buttons .button,
.ui.teal.button {
    background-color: #00B5AD;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.teal.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.teal.buttons .button:hover,
.ui.teal.button:hover {
    background-color: #009c95;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.teal.buttons .button:focus,
.ui.teal.button:focus {
    background-color: #008c86;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.teal.buttons .button:active,
.ui.teal.button:active {
    background-color: #00827c;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.teal.buttons .active.button,
.ui.teal.buttons .active.button:active,
.ui.teal.active.button,
.ui.teal.button .active.button:active {
    background-color: #009c95;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.teal.buttons .button,
.ui.basic.teal.button {
    -webkit-box-shadow: 0px 0px 0px 1px #00B5AD inset !important;
    box-shadow: 0px 0px 0px 1px #00B5AD inset !important;
    color: #00B5AD !important;
}
.ui.basic.teal.buttons .button:hover,
.ui.basic.teal.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #009c95 inset !important;
    box-shadow: 0px 0px 0px 1px #009c95 inset !important;
    color: #009c95 !important;
}
.ui.basic.teal.buttons .button:focus,
.ui.basic.teal.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #008c86 inset !important;
    box-shadow: 0px 0px 0px 1px #008c86 inset !important;
    color: #009c95 !important;
}
.ui.basic.teal.buttons .active.button,
.ui.basic.teal.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #009c95 inset !important;
    box-shadow: 0px 0px 0px 1px #009c95 inset !important;
    color: #00827c !important;
}
.ui.basic.teal.buttons .button:active,
.ui.basic.teal.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #00827c inset !important;
    box-shadow: 0px 0px 0px 1px #00827c inset !important;
    color: #00827c !important;
}
.ui.buttons:not(.vertical) > .basic.teal.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.teal.buttons .button,
.ui.inverted.teal.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #6DFFFF inset !important;
    box-shadow: 0px 0px 0px 2px #6DFFFF inset !important;
    color: #6DFFFF;
}
.ui.inverted.teal.buttons .button:hover,
.ui.inverted.teal.button:hover,
.ui.inverted.teal.buttons .button:focus,
.ui.inverted.teal.button:focus,
.ui.inverted.teal.buttons .button.active,
.ui.inverted.teal.button.active,
.ui.inverted.teal.buttons .button:active,
.ui.inverted.teal.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: rgba(0, 0, 0, 0.6);
}
.ui.inverted.teal.buttons .button:hover,
.ui.inverted.teal.button:hover {
    background-color: #54ffff;
}
.ui.inverted.teal.buttons .button:focus,
.ui.inverted.teal.button:focus {
    background-color: #44ffff;
}
.ui.inverted.teal.buttons .active.button,
.ui.inverted.teal.active.button {
    background-color: #54ffff;
}
.ui.inverted.teal.buttons .button:active,
.ui.inverted.teal.button:active {
    background-color: #3affff;
}

/* Inverted Basic */
.ui.inverted.teal.basic.buttons .button,
.ui.inverted.teal.buttons .basic.button,
.ui.inverted.teal.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.teal.basic.buttons .button:hover,
.ui.inverted.teal.buttons .basic.button:hover,
.ui.inverted.teal.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #54ffff inset !important;
    box-shadow: 0px 0px 0px 2px #54ffff inset !important;
    color: #6DFFFF !important;
}
.ui.inverted.teal.basic.buttons .button:focus,
.ui.inverted.teal.basic.buttons .button:focus,
.ui.inverted.teal.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #44ffff inset !important;
    box-shadow: 0px 0px 0px 2px #44ffff inset !important;
    color: #6DFFFF !important;
}
.ui.inverted.teal.basic.buttons .active.button,
.ui.inverted.teal.buttons .basic.active.button,
.ui.inverted.teal.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #54ffff inset !important;
    box-shadow: 0px 0px 0px 2px #54ffff inset !important;
    color: #6DFFFF !important;
}
.ui.inverted.teal.basic.buttons .button:active,
.ui.inverted.teal.buttons .basic.button:active,
.ui.inverted.teal.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #3affff inset !important;
    box-shadow: 0px 0px 0px 2px #3affff inset !important;
    color: #6DFFFF !important;
}

/*--- Olive ---*/

.ui.olive.buttons .button,
.ui.olive.button {
    background-color: #B5CC18;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.olive.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.olive.buttons .button:hover,
.ui.olive.button:hover {
    background-color: #a7bd0d;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.olive.buttons .button:focus,
.ui.olive.button:focus {
    background-color: #a0b605;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.olive.buttons .button:active,
.ui.olive.button:active {
    background-color: #8d9e13;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.olive.buttons .active.button,
.ui.olive.buttons .active.button:active,
.ui.olive.active.button,
.ui.olive.button .active.button:active {
    background-color: #aac109;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.olive.buttons .button,
.ui.basic.olive.button {
    -webkit-box-shadow: 0px 0px 0px 1px #B5CC18 inset !important;
    box-shadow: 0px 0px 0px 1px #B5CC18 inset !important;
    color: #B5CC18 !important;
}
.ui.basic.olive.buttons .button:hover,
.ui.basic.olive.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #a7bd0d inset !important;
    box-shadow: 0px 0px 0px 1px #a7bd0d inset !important;
    color: #a7bd0d !important;
}
.ui.basic.olive.buttons .button:focus,
.ui.basic.olive.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #a0b605 inset !important;
    box-shadow: 0px 0px 0px 1px #a0b605 inset !important;
    color: #a7bd0d !important;
}
.ui.basic.olive.buttons .active.button,
.ui.basic.olive.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #aac109 inset !important;
    box-shadow: 0px 0px 0px 1px #aac109 inset !important;
    color: #8d9e13 !important;
}
.ui.basic.olive.buttons .button:active,
.ui.basic.olive.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #8d9e13 inset !important;
    box-shadow: 0px 0px 0px 1px #8d9e13 inset !important;
    color: #8d9e13 !important;
}
.ui.buttons:not(.vertical) > .basic.olive.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.olive.buttons .button,
.ui.inverted.olive.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #D9E778 inset !important;
    box-shadow: 0px 0px 0px 2px #D9E778 inset !important;
    color: #D9E778;
}
.ui.inverted.olive.buttons .button:hover,
.ui.inverted.olive.button:hover,
.ui.inverted.olive.buttons .button:focus,
.ui.inverted.olive.button:focus,
.ui.inverted.olive.buttons .button.active,
.ui.inverted.olive.button.active,
.ui.inverted.olive.buttons .button:active,
.ui.inverted.olive.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: rgba(0, 0, 0, 0.6);
}
.ui.inverted.olive.buttons .button:hover,
.ui.inverted.olive.button:hover {
    background-color: #d8ea5c;
}
.ui.inverted.olive.buttons .button:focus,
.ui.inverted.olive.button:focus {
    background-color: #daef47;
}
.ui.inverted.olive.buttons .active.button,
.ui.inverted.olive.active.button {
    background-color: #daed59;
}
.ui.inverted.olive.buttons .button:active,
.ui.inverted.olive.button:active {
    background-color: #cddf4d;
}

/* Inverted Basic */
.ui.inverted.olive.basic.buttons .button,
.ui.inverted.olive.buttons .basic.button,
.ui.inverted.olive.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.olive.basic.buttons .button:hover,
.ui.inverted.olive.buttons .basic.button:hover,
.ui.inverted.olive.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #d8ea5c inset !important;
    box-shadow: 0px 0px 0px 2px #d8ea5c inset !important;
    color: #D9E778 !important;
}
.ui.inverted.olive.basic.buttons .button:focus,
.ui.inverted.olive.basic.buttons .button:focus,
.ui.inverted.olive.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #daef47 inset !important;
    box-shadow: 0px 0px 0px 2px #daef47 inset !important;
    color: #D9E778 !important;
}
.ui.inverted.olive.basic.buttons .active.button,
.ui.inverted.olive.buttons .basic.active.button,
.ui.inverted.olive.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #daed59 inset !important;
    box-shadow: 0px 0px 0px 2px #daed59 inset !important;
    color: #D9E778 !important;
}
.ui.inverted.olive.basic.buttons .button:active,
.ui.inverted.olive.buttons .basic.button:active,
.ui.inverted.olive.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #cddf4d inset !important;
    box-shadow: 0px 0px 0px 2px #cddf4d inset !important;
    color: #D9E778 !important;
}

/*--- Yellow ---*/

.ui.yellow.buttons .button,
.ui.yellow.button {
    background-color: #FBBD08;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.yellow.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.yellow.buttons .button:hover,
.ui.yellow.button:hover {
    background-color: #eaae00;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.yellow.buttons .button:focus,
.ui.yellow.button:focus {
    background-color: #daa300;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.yellow.buttons .button:active,
.ui.yellow.button:active {
    background-color: #cd9903;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.yellow.buttons .active.button,
.ui.yellow.buttons .active.button:active,
.ui.yellow.active.button,
.ui.yellow.button .active.button:active {
    background-color: #eaae00;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.yellow.buttons .button,
.ui.basic.yellow.button {
    -webkit-box-shadow: 0px 0px 0px 1px #FBBD08 inset !important;
    box-shadow: 0px 0px 0px 1px #FBBD08 inset !important;
    color: #FBBD08 !important;
}
.ui.basic.yellow.buttons .button:hover,
.ui.basic.yellow.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #eaae00 inset !important;
    box-shadow: 0px 0px 0px 1px #eaae00 inset !important;
    color: #eaae00 !important;
}
.ui.basic.yellow.buttons .button:focus,
.ui.basic.yellow.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #daa300 inset !important;
    box-shadow: 0px 0px 0px 1px #daa300 inset !important;
    color: #eaae00 !important;
}
.ui.basic.yellow.buttons .active.button,
.ui.basic.yellow.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #eaae00 inset !important;
    box-shadow: 0px 0px 0px 1px #eaae00 inset !important;
    color: #cd9903 !important;
}
.ui.basic.yellow.buttons .button:active,
.ui.basic.yellow.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #cd9903 inset !important;
    box-shadow: 0px 0px 0px 1px #cd9903 inset !important;
    color: #cd9903 !important;
}
.ui.buttons:not(.vertical) > .basic.yellow.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.yellow.buttons .button,
.ui.inverted.yellow.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #FFE21F inset !important;
    box-shadow: 0px 0px 0px 2px #FFE21F inset !important;
    color: #FFE21F;
}
.ui.inverted.yellow.buttons .button:hover,
.ui.inverted.yellow.button:hover,
.ui.inverted.yellow.buttons .button:focus,
.ui.inverted.yellow.button:focus,
.ui.inverted.yellow.buttons .button.active,
.ui.inverted.yellow.button.active,
.ui.inverted.yellow.buttons .button:active,
.ui.inverted.yellow.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: rgba(0, 0, 0, 0.6);
}
.ui.inverted.yellow.buttons .button:hover,
.ui.inverted.yellow.button:hover {
    background-color: #ffdf05;
}
.ui.inverted.yellow.buttons .button:focus,
.ui.inverted.yellow.button:focus {
    background-color: #f5d500;
}
.ui.inverted.yellow.buttons .active.button,
.ui.inverted.yellow.active.button {
    background-color: #ffdf05;
}
.ui.inverted.yellow.buttons .button:active,
.ui.inverted.yellow.button:active {
    background-color: #ebcd00;
}

/* Inverted Basic */
.ui.inverted.yellow.basic.buttons .button,
.ui.inverted.yellow.buttons .basic.button,
.ui.inverted.yellow.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.yellow.basic.buttons .button:hover,
.ui.inverted.yellow.buttons .basic.button:hover,
.ui.inverted.yellow.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #ffdf05 inset !important;
    box-shadow: 0px 0px 0px 2px #ffdf05 inset !important;
    color: #FFE21F !important;
}
.ui.inverted.yellow.basic.buttons .button:focus,
.ui.inverted.yellow.basic.buttons .button:focus,
.ui.inverted.yellow.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #f5d500 inset !important;
    box-shadow: 0px 0px 0px 2px #f5d500 inset !important;
    color: #FFE21F !important;
}
.ui.inverted.yellow.basic.buttons .active.button,
.ui.inverted.yellow.buttons .basic.active.button,
.ui.inverted.yellow.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #ffdf05 inset !important;
    box-shadow: 0px 0px 0px 2px #ffdf05 inset !important;
    color: #FFE21F !important;
}
.ui.inverted.yellow.basic.buttons .button:active,
.ui.inverted.yellow.buttons .basic.button:active,
.ui.inverted.yellow.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #ebcd00 inset !important;
    box-shadow: 0px 0px 0px 2px #ebcd00 inset !important;
    color: #FFE21F !important;
}

/*-------------------
       Primary
--------------------*/


/*--- Standard ---*/

.ui.primary.buttons .button,
.ui.primary.button {
    background-color: #2185D0;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.primary.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.primary.buttons .button:hover,
.ui.primary.button:hover {
    background-color: #1678c2;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.primary.buttons .button:focus,
.ui.primary.button:focus {
    background-color: #0d71bb;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.primary.buttons .button:active,
.ui.primary.button:active {
    background-color: #1a69a4;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.primary.buttons .active.button,
.ui.primary.buttons .active.button:active,
.ui.primary.active.button,
.ui.primary.button .active.button:active {
    background-color: #1279c6;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.primary.buttons .button,
.ui.basic.primary.button {
    -webkit-box-shadow: 0px 0px 0px 1px #2185D0 inset !important;
    box-shadow: 0px 0px 0px 1px #2185D0 inset !important;
    color: #2185D0 !important;
}
.ui.basic.primary.buttons .button:hover,
.ui.basic.primary.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #1678c2 inset !important;
    box-shadow: 0px 0px 0px 1px #1678c2 inset !important;
    color: #1678c2 !important;
}
.ui.basic.primary.buttons .button:focus,
.ui.basic.primary.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #0d71bb inset !important;
    box-shadow: 0px 0px 0px 1px #0d71bb inset !important;
    color: #1678c2 !important;
}
.ui.basic.primary.buttons .active.button,
.ui.basic.primary.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #1279c6 inset !important;
    box-shadow: 0px 0px 0px 1px #1279c6 inset !important;
    color: #1a69a4 !important;
}
.ui.basic.primary.buttons .button:active,
.ui.basic.primary.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #1a69a4 inset !important;
    box-shadow: 0px 0px 0px 1px #1a69a4 inset !important;
    color: #1a69a4 !important;
}
.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.primary.buttons .button,
.ui.inverted.primary.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #54C8FF inset !important;
    box-shadow: 0px 0px 0px 2px #54C8FF inset !important;
    color: #54C8FF;
}
.ui.inverted.primary.buttons .button:hover,
.ui.inverted.primary.button:hover,
.ui.inverted.primary.buttons .button:focus,
.ui.inverted.primary.button:focus,
.ui.inverted.primary.buttons .button.active,
.ui.inverted.primary.button.active,
.ui.inverted.primary.buttons .button:active,
.ui.inverted.primary.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.primary.buttons .button:hover,
.ui.inverted.primary.button:hover {
    background-color: #3ac0ff;
}
.ui.inverted.primary.buttons .button:focus,
.ui.inverted.primary.button:focus {
    background-color: #2bbbff;
}
.ui.inverted.primary.buttons .active.button,
.ui.inverted.primary.active.button {
    background-color: #3ac0ff;
}
.ui.inverted.primary.buttons .button:active,
.ui.inverted.primary.button:active {
    background-color: #21b8ff;
}

/* Inverted Basic */
.ui.inverted.primary.basic.buttons .button,
.ui.inverted.primary.buttons .basic.button,
.ui.inverted.primary.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.primary.basic.buttons .button:hover,
.ui.inverted.primary.buttons .basic.button:hover,
.ui.inverted.primary.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
    box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
    color: #54C8FF !important;
}
.ui.inverted.primary.basic.buttons .button:focus,
.ui.inverted.primary.basic.buttons .button:focus,
.ui.inverted.primary.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #2bbbff inset !important;
    box-shadow: 0px 0px 0px 2px #2bbbff inset !important;
    color: #54C8FF !important;
}
.ui.inverted.primary.basic.buttons .active.button,
.ui.inverted.primary.buttons .basic.active.button,
.ui.inverted.primary.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
    box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;
    color: #54C8FF !important;
}
.ui.inverted.primary.basic.buttons .button:active,
.ui.inverted.primary.buttons .basic.button:active,
.ui.inverted.primary.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #21b8ff inset !important;
    box-shadow: 0px 0px 0px 2px #21b8ff inset !important;
    color: #54C8FF !important;
}

/*-------------------
      Secondary
--------------------*/


/* Standard */
.ui.secondary.buttons .button,
.ui.secondary.button {
    background-color: #1B1C1D;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.secondary.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.secondary.buttons .button:hover,
.ui.secondary.button:hover {
    background-color: #27292a;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.secondary.buttons .button:focus,
.ui.secondary.button:focus {
    background-color: #2e3032;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.secondary.buttons .button:active,
.ui.secondary.button:active {
    background-color: #343637;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.secondary.buttons .active.button,
.ui.secondary.buttons .active.button:active,
.ui.secondary.active.button,
.ui.secondary.button .active.button:active {
    background-color: #27292a;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.secondary.buttons .button,
.ui.basic.secondary.button {
    -webkit-box-shadow: 0px 0px 0px 1px #1B1C1D inset !important;
    box-shadow: 0px 0px 0px 1px #1B1C1D inset !important;
    color: #1B1C1D !important;
}
.ui.basic.secondary.buttons .button:hover,
.ui.basic.secondary.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #27292a inset !important;
    box-shadow: 0px 0px 0px 1px #27292a inset !important;
    color: #27292a !important;
}
.ui.basic.secondary.buttons .button:focus,
.ui.basic.secondary.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #2e3032 inset !important;
    box-shadow: 0px 0px 0px 1px #2e3032 inset !important;
    color: #27292a !important;
}
.ui.basic.secondary.buttons .active.button,
.ui.basic.secondary.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #27292a inset !important;
    box-shadow: 0px 0px 0px 1px #27292a inset !important;
    color: #343637 !important;
}
.ui.basic.secondary.buttons .button:active,
.ui.basic.secondary.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #343637 inset !important;
    box-shadow: 0px 0px 0px 1px #343637 inset !important;
    color: #343637 !important;
}
.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {
    margin-left: -1px;
}

/* Inverted */
.ui.inverted.secondary.buttons .button,
.ui.inverted.secondary.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px #545454 inset !important;
    box-shadow: 0px 0px 0px 2px #545454 inset !important;
    color: #545454;
}
.ui.inverted.secondary.buttons .button:hover,
.ui.inverted.secondary.button:hover,
.ui.inverted.secondary.buttons .button:focus,
.ui.inverted.secondary.button:focus,
.ui.inverted.secondary.buttons .button.active,
.ui.inverted.secondary.button.active,
.ui.inverted.secondary.buttons .button:active,
.ui.inverted.secondary.button:active {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #FFFFFF;
}
.ui.inverted.secondary.buttons .button:hover,
.ui.inverted.secondary.button:hover {
    background-color: #616161;
}
.ui.inverted.secondary.buttons .button:focus,
.ui.inverted.secondary.button:focus {
    background-color: #686868;
}
.ui.inverted.secondary.buttons .active.button,
.ui.inverted.secondary.active.button {
    background-color: #616161;
}
.ui.inverted.secondary.buttons .button:active,
.ui.inverted.secondary.button:active {
    background-color: #6e6e6e;
}

/* Inverted Basic */
.ui.inverted.secondary.basic.buttons .button,
.ui.inverted.secondary.buttons .basic.button,
.ui.inverted.secondary.basic.button {
    background-color: transparent;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;
    color: #FFFFFF !important;
}
.ui.inverted.secondary.basic.buttons .button:hover,
.ui.inverted.secondary.buttons .basic.button:hover,
.ui.inverted.secondary.basic.button:hover {
    -webkit-box-shadow: 0px 0px 0px 2px #616161 inset !important;
    box-shadow: 0px 0px 0px 2px #616161 inset !important;
    color: #545454 !important;
}
.ui.inverted.secondary.basic.buttons .button:focus,
.ui.inverted.secondary.basic.buttons .button:focus,
.ui.inverted.secondary.basic.button:focus {
    -webkit-box-shadow: 0px 0px 0px 2px #686868 inset !important;
    box-shadow: 0px 0px 0px 2px #686868 inset !important;
    color: #545454 !important;
}
.ui.inverted.secondary.basic.buttons .active.button,
.ui.inverted.secondary.buttons .basic.active.button,
.ui.inverted.secondary.basic.active.button {
    -webkit-box-shadow: 0px 0px 0px 2px #616161 inset !important;
    box-shadow: 0px 0px 0px 2px #616161 inset !important;
    color: #545454 !important;
}
.ui.inverted.secondary.basic.buttons .button:active,
.ui.inverted.secondary.buttons .basic.button:active,
.ui.inverted.secondary.basic.button:active {
    -webkit-box-shadow: 0px 0px 0px 2px #6e6e6e inset !important;
    box-shadow: 0px 0px 0px 2px #6e6e6e inset !important;
    color: #545454 !important;
}

/*---------------
    Positive
----------------*/


/* Standard */
.ui.positive.buttons .button,
.ui.positive.button {
    background-color: #21BA45;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.positive.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.positive.buttons .button:hover,
.ui.positive.button:hover {
    background-color: #16ab39;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.positive.buttons .button:focus,
.ui.positive.button:focus {
    background-color: #0ea432;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.positive.buttons .button:active,
.ui.positive.button:active {
    background-color: #198f35;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.positive.buttons .active.button,
.ui.positive.buttons .active.button:active,
.ui.positive.active.button,
.ui.positive.button .active.button:active {
    background-color: #13ae38;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.positive.buttons .button,
.ui.basic.positive.button {
    -webkit-box-shadow: 0px 0px 0px 1px #21BA45 inset !important;
    box-shadow: 0px 0px 0px 1px #21BA45 inset !important;
    color: #21BA45 !important;
}
.ui.basic.positive.buttons .button:hover,
.ui.basic.positive.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #16ab39 inset !important;
    box-shadow: 0px 0px 0px 1px #16ab39 inset !important;
    color: #16ab39 !important;
}
.ui.basic.positive.buttons .button:focus,
.ui.basic.positive.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #0ea432 inset !important;
    box-shadow: 0px 0px 0px 1px #0ea432 inset !important;
    color: #16ab39 !important;
}
.ui.basic.positive.buttons .active.button,
.ui.basic.positive.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #13ae38 inset !important;
    box-shadow: 0px 0px 0px 1px #13ae38 inset !important;
    color: #198f35 !important;
}
.ui.basic.positive.buttons .button:active,
.ui.basic.positive.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #198f35 inset !important;
    box-shadow: 0px 0px 0px 1px #198f35 inset !important;
    color: #198f35 !important;
}
.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {
    margin-left: -1px;
}

/*---------------
     Negative
----------------*/


/* Standard */
.ui.negative.buttons .button,
.ui.negative.button {
    background-color: #DB2828;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
}
.ui.negative.button {
    -webkit-box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.negative.buttons .button:hover,
.ui.negative.button:hover {
    background-color: #d01919;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.negative.buttons .button:focus,
.ui.negative.button:focus {
    background-color: #ca1010;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.negative.buttons .button:active,
.ui.negative.button:active {
    background-color: #b21e1e;
    color: #FFFFFF;
    text-shadow: none;
}
.ui.negative.buttons .active.button,
.ui.negative.buttons .active.button:active,
.ui.negative.active.button,
.ui.negative.button .active.button:active {
    background-color: #d41515;
    color: #FFFFFF;
    text-shadow: none;
}

/* Basic */
.ui.basic.negative.buttons .button,
.ui.basic.negative.button {
    -webkit-box-shadow: 0px 0px 0px 1px #DB2828 inset !important;
    box-shadow: 0px 0px 0px 1px #DB2828 inset !important;
    color: #DB2828 !important;
}
.ui.basic.negative.buttons .button:hover,
.ui.basic.negative.button:hover {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #d01919 inset !important;
    box-shadow: 0px 0px 0px 1px #d01919 inset !important;
    color: #d01919 !important;
}
.ui.basic.negative.buttons .button:focus,
.ui.basic.negative.button:focus {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #ca1010 inset !important;
    box-shadow: 0px 0px 0px 1px #ca1010 inset !important;
    color: #d01919 !important;
}
.ui.basic.negative.buttons .active.button,
.ui.basic.negative.active.button {
    background: transparent !important;
    -webkit-box-shadow: 0px 0px 0px 1px #d41515 inset !important;
    box-shadow: 0px 0px 0px 1px #d41515 inset !important;
    color: #b21e1e !important;
}
.ui.basic.negative.buttons .button:active,
.ui.basic.negative.button:active {
    -webkit-box-shadow: 0px 0px 0px 1px #b21e1e inset !important;
    box-shadow: 0px 0px 0px 1px #b21e1e inset !important;
    color: #b21e1e !important;
}
.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {
    margin-left: -1px;
}


/*******************************
            Groups
*******************************/

.ui.buttons {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    font-size: 0em;
    vertical-align: baseline;
    margin: 0em 0.25em 0em 0em;
}
.ui.buttons:not(.basic):not(.inverted) {
    -webkit-box-shadow: none;
    box-shadow: none;
}

/* Clearfix */
.ui.buttons:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}

/* Standard Group */
.ui.buttons .button {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 auto;
    flex: 1 0 auto;
    margin: 0em;
    border-radius: 0em;
    margin: 0px 0px 0px 0px;
}
.ui.buttons > .ui.button:not(.basic):not(.inverted),
.ui.buttons:not(.basic):not(.inverted) > .button {
    -webkit-box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px rgba(34, 36, 38, 0.15) inset;
}
.ui.buttons .button:first-child {
    border-left: none;
    margin-left: 0em;
    border-top-left-radius: 0.28571429rem;
    border-bottom-left-radius: 0.28571429rem;
}
.ui.buttons .button:last-child {
    border-top-right-radius: 0.28571429rem;
    border-bottom-right-radius: 0.28571429rem;
}

/* Vertical  Style */
.ui.vertical.buttons {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
.ui.vertical.buttons .button {
    display: block;
    float: none;
    width: 100%;
    margin: 0px 0px 0px 0px;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-radius: 0em;
}
.ui.vertical.buttons .button:first-child {
    border-top-left-radius: 0.28571429rem;
    border-top-right-radius: 0.28571429rem;
}
.ui.vertical.buttons .button:last-child {
    margin-bottom: 0px;
    border-bottom-left-radius: 0.28571429rem;
    border-bottom-right-radius: 0.28571429rem;
}
.ui.vertical.buttons .button:only-child {
    border-radius: 0.28571429rem;
}

/*******************************
           Breadcrumb
*******************************/

.ui.breadcrumb {
  line-height: 1;
  display: inline-block;
  margin: 0em 0em;
  vertical-align: middle;
}

.ui.breadcrumb:first-child {
  margin-top: 0em;
}

.ui.breadcrumb:last-child {
  margin-bottom: 0em;
}

/*******************************
          Content
*******************************/

/* Divider */

.ui.breadcrumb .divider {
  display: inline-block;
  opacity: 0.7;
  margin: 0em 0.21428571rem 0em;
  font-size: 0.92857143em;
  color: rgba(0, 0, 0, 0.4);
  vertical-align: baseline;
}

/* Link */

.ui.breadcrumb a {
  color: #4183C4;
}

.ui.breadcrumb a:hover {
  color: #1e70bf;
}

/* Icon Divider */

.ui.breadcrumb .icon.divider {
  font-size: 0.85714286em;
  vertical-align: baseline;
}

/* Section */

.ui.breadcrumb a.section {
  cursor: pointer;
}

.ui.breadcrumb .section {
  display: inline-block;
  margin: 0em;
  padding: 0em;
}

/* Loose Coupling */

.ui.breadcrumb.segment {
  display: inline-block;
  padding: 0.78571429em 1em;
}

/*******************************
            States
*******************************/

.ui.breadcrumb .active.section {
  font-weight: bold;
}

/*******************************
           Variations
*******************************/

.ui.mini.breadcrumb {
  font-size: 0.78571429rem;
}

.ui.tiny.breadcrumb {
  font-size: 0.85714286rem;
}

.ui.small.breadcrumb {
  font-size: 0.92857143rem;
}

.ui.breadcrumb {
  font-size: 1rem;
}

.ui.large.breadcrumb {
  font-size: 1.14285714rem;
}

.ui.big.breadcrumb {
  font-size: 1.28571429rem;
}

.ui.huge.breadcrumb {
  font-size: 1.42857143rem;
}

.ui.massive.breadcrumb {
  font-size: 1.71428571rem;
}

/* CUSTOM */

a {
    color:#1FA12E!important
}

i.icon {
    display: inline-block;
    opacity: 1;
    margin: 0 .25rem 0 0;
    width: 1.18em;
    height: 1em;
    font-family: Icons;
    font-style: normal;
    font-weight: 400;
    text-decoration: inherit;
    text-align: center;
    speak: none;
    font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

i.icon.angle.right:before {
    content: ">";
    font-weight: bold;
}

`;